import { AccountBalanceTypeDescriptions, YearEndCloseService, FinancialReportTypes, AccountService, AccountBalanceTypeService, AccountGroupService, CategoryNodeService, IncludeType, AccountBalanceService, FiscalYearService, AccountingServicesModule } from '@accounting/accounting-services';
import { DecimalPipe, CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Component, ViewChild, ViewEncapsulation, Input, Output, Pipe, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UpgradeModule } from '@angular/upgrade/static';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BentoModule } from '@bento/bento-ng';
import { BentoFlexGridControlModule } from '@bento/bento-ng-flexgrid-control';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1 from '@ngx-translate/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { createFeatureSelector, createSelector, select, Store, StoreModule } from '@ngrx/store';
import { ofType, Actions, Effect, EffectsModule } from '@ngrx/effects';
import { AddAccountModule } from '@accounting/add-account';
import { BehaviorSubject, Subject, combineLatest, Subscription, of } from 'rxjs';
import { takeUntil, first, map, concatMap, catchError, switchMap, mergeMap } from 'rxjs/operators';
import { __awaiter, __decorate } from 'tslib';
import { createEntityAdapter } from '@ngrx/entity';
import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';
import { parseISO, format } from 'date-fns';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@ngrx/store';
import * as ɵngcc4 from '@bento/bento-ng';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@grapecity/wijmo.angular2.grid';
import * as ɵngcc8 from '@bento/bento-ng-flexgrid-control';
import * as ɵngcc9 from '@grapecity/wijmo.angular2.input';
import * as ɵngcc10 from '@accounting/add-account';
import * as ɵngcc11 from '@ngrx/effects';
import * as ɵngcc12 from '@accounting/accounting-services';

const _c0 = ["bmyecYearEndCloseMainCloseYear"];
function BmyecYearEndCloseModalComponent_div_24_bmyec_net_income_distribution_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmyec-net-income-distribution");
} }
function BmyecYearEndCloseModalComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "div", 14)(3, "div", 15);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 16)(7, "div", 2)(8, "div", 17)(9, "label", 18);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "bento-toggle", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function BmyecYearEndCloseModalComponent_div_24_Template_bento_toggle_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.zeroOutBalanceChanged($event); });
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(13, "div", 2)(14, "div", 20);
    ɵngcc0.ɵɵtemplate(15, BmyecYearEndCloseModalComponent_div_24_bmyec_net_income_distribution_15_Template, 1, 0, "bmyec-net-income-distribution", 21);
    ɵngcc0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 4, "bmyec_closing_options_label"));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(11, 6, "bmyec_zero_out_account_balances"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.yearEndCloseSettings.enableZeroOutAccountBalances);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.yearEndCloseSettings.enableZeroOutAccountBalances);
} }
const _c1 = function (a0) { return { value: a0 }; };
const _c2 = ["netIncomeDistGrid"];
const _c3 = ["toolbar"];
function BmyecNetIncomeDistributionGridComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const $data_r7 = ctx.data;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", $data_r7.row.displayString, " ");
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const row_r17 = ctx.row;
    ɵngcc0.ɵɵtextInterpolate1(" ", row_r17.index + 1, " ");
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-checkbox", 16);
    ɵngcc0.ɵɵlistener("change", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_4_Template_bento_checkbox_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onHeaderCheckboxChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r10.allSelected())("indeterminate", ctx_r10.isHeaderIndeterminate())("disabled", ctx_r10.isReadOnly);
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-checkbox", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_5_Template_bento_checkbox_ngModelChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r23); const item_r20 = restoredCtx.item; return item_r20.selected = $event; })("change", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_5_Template_bento_checkbox_change_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r23); const row_r21 = restoredCtx.row; const item_r20 = restoredCtx.item; const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.setRowSelection(row_r21.index, item_r20); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.item;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", item_r20.selected)("disabled", ctx_r11.isReadOnly);
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bento-combobox", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_8_Template_bento_combobox_ngModelChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r29); const cell_r25 = restoredCtx.cell; return cell_r25.value = $event; })("ngModelChange", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_8_Template_bento_combobox_ngModelChange_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r29); const cell_r25 = restoredCtx.cell; const row_r26 = restoredCtx.row; const item_r27 = restoredCtx.item; const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.onAccountChange(cell_r25.value, row_r26.index, item_r27); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const cell_r25 = ctx.cell;
    const row_r26 = ctx.row;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(3);
    const _r2 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("ngModel", cell_r25.value)("itemsObservable", ctx_r12.getEquityAccountObservable(row_r26.index))("options", ctx_r12.equityAccountComboboxOptions)("appendTo", _r0)("rowTemplate", _r2)("placeholder", ɵngcc0.ɵɵpipeBind1(1, 7, "bmyec_equity_account_select"));
    ɵngcc0.ɵɵattribute("data-qe-id", "bmyec-distribution-grid-accounts-combobox-" + row_r26.index);
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const item_r31 = ctx.item;
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r31.account.displayString, " ");
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "wj-input-number", 19);
    ɵngcc0.ɵɵlistener("valueChange", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_12_Template_wj_input_number_valueChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r35); const item_r32 = restoredCtx.item; return item_r32.distributionPercentage = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r32 = ctx.item;
    const row_r33 = ctx.row;
    ɵngcc0.ɵɵproperty("isRequired", false)("value", item_r32.distributionPercentage);
    ɵngcc0.ɵɵattribute("data-qe-id", "bmyec-distribution-grid-ditributionPercentage-" + row_r33.index);
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "bmyecFormatNumberPipe");
} if (rf & 2) {
    const item_r36 = ctx.item;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(1, 1, item_r36.distributionAmount, ctx_r15.constants.AMOUNT_FORMAT_NUMBER), " ");
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    const _r40 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "wj-input-number", 20);
    ɵngcc0.ɵɵlistener("valueChange", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_16_Template_wj_input_number_valueChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r40); const item_r37 = restoredCtx.item; return item_r37.distributionAmount = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r37 = ctx.item;
    const row_r38 = ctx.row;
    ɵngcc0.ɵɵproperty("isRequired", false)("value", item_r37.distributionAmount);
    ɵngcc0.ɵɵattribute("data-qe-id", "bmyec-distribution-grid-ditributionAmount-" + row_r38.index);
} }
function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "wj-flex-grid", 9, 10);
    ɵngcc0.ɵɵlistener("itemsSourceChanging", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template_wj_flex_grid_itemsSourceChanging_0_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.itemsSourceChanging(); })("itemsSourceChanged", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template_wj_flex_grid_itemsSourceChanged_0_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.itemsSourceChanged(); })("initialized", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template_wj_flex_grid_initialized_0_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r44 = ɵngcc0.ɵɵnextContext(); return ctx_r44.gridInitialized(); })("refreshing", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template_wj_flex_grid_refreshing_0_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r45 = ɵngcc0.ɵɵnextContext(); return ctx_r45.refreshGridLayout(); })("click", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template_wj_flex_grid_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ctx_r46.onCellClicked($event); })("cellEditEnded", function BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template_wj_flex_grid_cellEditEnded_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ctx_r47.cellEditEnded($event); });
    ɵngcc0.ɵɵtemplate(2, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_2_Template, 1, 1, "ng-template", 11);
    ɵngcc0.ɵɵelementStart(3, "wj-flex-grid-column", 12);
    ɵngcc0.ɵɵtemplate(4, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_4_Template, 1, 3, "ng-template", 11);
    ɵngcc0.ɵɵtemplate(5, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_5_Template, 1, 2, "ng-template", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "wj-flex-grid-column", 13);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵtemplate(8, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_8_Template, 2, 9, "ng-template", 11);
    ɵngcc0.ɵɵtemplate(9, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_9_Template, 1, 1, "ng-template", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "wj-flex-grid-column", 14);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵtemplate(12, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_12_Template, 1, 3, "ng-template", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "wj-flex-grid-column", 15);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵtemplate(15, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_15_Template, 2, 4, "ng-template", 11);
    ɵngcc0.ɵɵtemplate(16, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_ng_template_16_Template, 1, 3, "ng-template", 11);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("itemsSource", ctx_r4.netIncomeDistributions)("selectionMode", "Row")("showSort", false)("showErrors", ctx_r4.showErrors)("validateEdits", false)("isReadOnly", ctx_r4.isReadOnly)("itemFormatter", ctx_r4.itemFormatter)("autoRowHeights", true)("quickAutoSize", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cellType", "RowHeader");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("width", 30)("isReadOnly", true)("allowSorting", ctx_r4.allowSorting)("allowDragging", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cellType", "ColumnHeader");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cellType", "Cell");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("header", ɵngcc0.ɵɵpipeBind1(7, 37, "bmyec_equity_account"))("width", "*")("minWidth", 100)("binding", "account")("allowSorting", ctx_r4.allowSorting)("allowDragging", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cellType", "CellEdit");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cellType", "Cell");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("header", ɵngcc0.ɵɵpipeBind1(11, 39, "bmyec_percentage"))("width", "*")("minWidth", 100)("allowSorting", ctx_r4.allowSorting)("allowDragging", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cellType", "CellEdit");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("header", ɵngcc0.ɵɵpipeBind1(14, 41, "bmyec_amount"))("width", "*")("minWidth", 100)("allowSorting", ctx_r4.allowSorting)("allowDragging", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cellType", "Cell");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cellType", "CellEdit");
} }
function BmyecNetIncomeDistributionGridComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r49 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "div", 22);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelement(3, "div", 23);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "div", 24)(6, "button", 25);
    ɵngcc0.ɵɵlistener("click", function BmyecNetIncomeDistributionGridComponent_div_9_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r49); const ctx_r48 = ɵngcc0.ɵɵnextContext(); return ctx_r48.openAddEquityAccountModal(); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(2, 3, "bmyec_no_equity_accounts_title"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(4, 5, "bmyec_no_equity_accounts_message"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 7, "bmyec_add_equity_account"), " ");
} }
function BmyecNetIncomeDistributionGridComponent_bmaa_add_account_10_Template(rf, ctx) { if (rf & 1) {
    const _r51 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bmaa-add-account", 26);
    ɵngcc0.ɵɵlistener("modalCancel", function BmyecNetIncomeDistributionGridComponent_bmaa_add_account_10_Template_bmaa_add_account_modalCancel_0_listener() { ɵngcc0.ɵɵrestoreView(_r51); const ctx_r50 = ɵngcc0.ɵɵnextContext(); return ctx_r50.setModalOpenedAsFalse(); })("modalClose", function BmyecNetIncomeDistributionGridComponent_bmaa_add_account_10_Template_bmaa_add_account_modalClose_0_listener() { ɵngcc0.ɵɵrestoreView(_r51); const ctx_r52 = ɵngcc0.ɵɵnextContext(); return ctx_r52.setIsCloseModalAsTrue(); })("accountAdded", function BmyecNetIncomeDistributionGridComponent_bmaa_add_account_10_Template_bmaa_add_account_accountAdded_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r51); const ctx_r53 = ɵngcc0.ɵɵnextContext(); return ctx_r53.addNewEquityAccount($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ownerId", ctx_r6.ownerId)("passedInData", ctx_r6.addAccountSettings);
} }
const _c4 = function (a0) { return { "bmyec-distribution-difference": a0 }; };
function BmyecNetIncomeDistributionComponent_bmyec_net_income_distribution_table_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmyec-net-income-distribution-table", 4);
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("distributionSummary", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r0.distributionSummary$));
} }
var AccountBalanceTypeActionTypes;
(function (AccountBalanceTypeActionTypes) {
    AccountBalanceTypeActionTypes["LoadAccountBalanceTypes"] = "[BMYEC AccountBalanceType] Load AccountBalanceTypes";
    AccountBalanceTypeActionTypes["LoadAccountBalanceTypesSuccess"] = "[BMYEC AccountBalanceType] Load AccountBalanceTypes Success";
    AccountBalanceTypeActionTypes["LoadAccountBalanceTypesFailure"] = "[BMYEC AccountBalanceType] Load AccountBalanceTypes Failure";
})(AccountBalanceTypeActionTypes || (AccountBalanceTypeActionTypes = {}));
/**
 * Load Account Balance Types connected to ownerId.
 */
class LoadAccountBalanceTypes {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountBalanceTypeActionTypes.LoadAccountBalanceTypes;
    }
}
/**
 * Account Balance Types successfully loaded, sent in data property with Account Balance Types array.
 */
class LoadAccountBalanceTypesSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountBalanceTypeActionTypes.LoadAccountBalanceTypesSuccess;
    }
}
/**
 * Loading of Account Balance Types failed returning the error property.
 */
class LoadAccountBalanceTypesFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountBalanceTypeActionTypes.LoadAccountBalanceTypesFailure;
    }
}

const accountBalanceTypeFeatureKey = 'accountBalanceTypeState';
const initialState$7 = {
    accountBalanceTypes: [],
    accountBalanceTypesLoading: false,
    accountBalanceTypesLoaded: false,
    accountBalanceTypesLoadingFailed: false,
};
/**
 * Updates the state based on the action and its payload.
 *
 * @param state State object with default initial values.
 * @param action The action that will define what properties will be set and/or updated on the store
 * taken from the payload.data property.
 */
function reducer$7(state = initialState$7, action) {
    switch (action.type) {
        case AccountBalanceTypeActionTypes.LoadAccountBalanceTypes:
            return Object.assign(Object.assign({}, state), { accountBalanceTypes: [], accountBalanceTypesLoading: true, accountBalanceTypesLoaded: false, accountBalanceTypesLoadingFailed: false });
        case AccountBalanceTypeActionTypes.LoadAccountBalanceTypesSuccess:
            return Object.assign(Object.assign({}, state), { accountBalanceTypes: action.payload.data, accountBalanceTypesLoading: false, accountBalanceTypesLoaded: true, accountBalanceTypesLoadingFailed: false });
        case AccountBalanceTypeActionTypes.LoadAccountBalanceTypesFailure:
            return Object.assign(Object.assign({}, state), { accountBalanceTypesLoading: false, accountBalanceTypesLoaded: false, accountBalanceTypesLoadingFailed: true });
        default:
            return state;
    }
}

var EquityAccountStateActionTypes;
(function (EquityAccountStateActionTypes) {
    EquityAccountStateActionTypes["AddEquityAccount"] = "[BMYEC AddEquityAccount] Add EquityAccount";
    EquityAccountStateActionTypes["LoadEquityAccounts"] = "[BMYEC EquityAccountState] Load EquityAccountStates";
    EquityAccountStateActionTypes["LoadEquityAccountsSuccess"] = "[BMYEC EquityAccountState] Load EquityAccountStates Success";
    EquityAccountStateActionTypes["LoadEquityAccountsFailure"] = "[BMYEC EquityAccountState] Load EquityAccountStates Failure";
    EquityAccountStateActionTypes["SetSelectedEquityAccounts"] = "[BMYEC EquityAccountState] Set SelectedEquityAccount";
})(EquityAccountStateActionTypes || (EquityAccountStateActionTypes = {}));
/**
 * Load Equity Accounts connected to ownerId.
 */
class LoadEquityAccounts {
    constructor(payload) {
        this.payload = payload;
        this.type = EquityAccountStateActionTypes.LoadEquityAccounts;
    }
}
/**
 * Equity Accounts successfully loaded, sent in data property with Account array.
 */
class LoadEquityAccountsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = EquityAccountStateActionTypes.LoadEquityAccountsSuccess;
    }
}
/**
 * Equity Accounts loading failed.
 */
class LoadEquityAccountsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = EquityAccountStateActionTypes.LoadEquityAccountsFailure;
    }
}
/**
 * Sets the selected equity accounts data.
 */
class SetSelectedEquityAccounts {
    constructor(payload) {
        this.payload = payload;
        this.type = EquityAccountStateActionTypes.SetSelectedEquityAccounts;
    }
}
/**
 * Add properties to account added via modal.
 */
class AddEquityAccount {
    constructor(payload) {
        this.payload = payload;
        this.type = EquityAccountStateActionTypes.AddEquityAccount;
    }
}

const equityAccountStateFeatureKey = 'equityAccountState';
const initialState$6 = {
    equityAccounts: [],
    equityAccountsLoading: false,
    equityAccountsLoaded: false,
    equityAccountsLoadingFailed: false,
    selectedEquityAccounts: [],
};
/**
 * Updates the state based on the action and its payload.
 *
 * @param state State object with default initial values.
 * @param action The action that will define what properties will be set and/or updated on the store
 * taken from the payload.data property.
 */
function reducer$6(state = initialState$6, action) {
    switch (action.type) {
        case EquityAccountStateActionTypes.LoadEquityAccounts:
            return Object.assign(Object.assign({}, state), { equityAccounts: [], equityAccountsLoading: true, equityAccountsLoaded: false, equityAccountsLoadingFailed: false });
        case EquityAccountStateActionTypes.LoadEquityAccountsSuccess:
            return Object.assign(Object.assign({}, state), { equityAccounts: action.payload.data, equityAccountsLoading: false, equityAccountsLoaded: true, equityAccountsLoadingFailed: false });
        case EquityAccountStateActionTypes.LoadEquityAccountsFailure:
            return Object.assign(Object.assign({}, state), { equityAccountsLoading: false, equityAccountsLoaded: false, equityAccountsLoadingFailed: true });
        case EquityAccountStateActionTypes.SetSelectedEquityAccounts:
            return Object.assign(Object.assign({}, state), { selectedEquityAccounts: action.payload.data });
        case EquityAccountStateActionTypes.AddEquityAccount:
            const equityAccounts = [
                ...state.equityAccounts,
                action.payload.equityAccount
            ];
            return Object.assign(Object.assign({}, state), { equityAccounts });
        default:
            return state;
    }
}

var NetIncomeDistributionDataActionTypes;
(function (NetIncomeDistributionDataActionTypes) {
    NetIncomeDistributionDataActionTypes["SetNetIncomeDistributions"] = "[BMYEC NetIncomeDistributionData] Set NetIncomeDistributions";
    NetIncomeDistributionDataActionTypes["LoadNetIncomeTotals"] = "[BMYEC NetIncomeTotal] Load NetIncomeTotals";
    NetIncomeDistributionDataActionTypes["LoadNetIncomeTotalsSuccess"] = "[BMYEC NetIncomeTotal] Load NetIncomeTotals Success";
    NetIncomeDistributionDataActionTypes["LoadNetIncomeTotalsFailure"] = "[BMYEC NetIncomeTotal] Load NetIncomeTotals Failure";
    NetIncomeDistributionDataActionTypes["AddNetIncomeDistribution"] = "[BMYEC NetIncomeDistributionData] Add NetIncomeDistribution";
    NetIncomeDistributionDataActionTypes["UpdateNetIncomeDistribution"] = "[BMYEC NetIncomeDistributionData] Update NetIncomeDistribution";
    NetIncomeDistributionDataActionTypes["RemoveNetIncomeDistribution"] = "[BMYEC NetIncomeDistributionData] Remove NetIncomeDistribution";
    NetIncomeDistributionDataActionTypes["UpdateNetIncomeDistributionsSummary"] = "[BMYEC NetIncomeDistributionData] Update NetIncomeDistributions Summary";
    NetIncomeDistributionDataActionTypes["SetNetIncomeDistributionsSelection"] = "[BMYEC NetIncomeDistributionData] Set NetIncomeDistributionsSelection";
    NetIncomeDistributionDataActionTypes["SetEquityAccountToNetIncomeDistribution"] = "[BMYEC NetIncomeDistributionData] Set EquityAccountToNetIncomeDistribution";
    NetIncomeDistributionDataActionTypes["ResetNetIncomeDistributions"] = "[BMYEC NetIncomeDistributionData] Reset NetIncomeDistributions";
})(NetIncomeDistributionDataActionTypes || (NetIncomeDistributionDataActionTypes = {}));
/**
 * Set net income distributions.
 */
class SetNetIncomeDistributions {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.SetNetIncomeDistributions;
    }
}
/**
 * To load net income totals connected to ownerId and adjusted balance type.
 */
class LoadNetIncomeTotals {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.LoadNetIncomeTotals;
    }
}
/**
 * When net income totals, sent in data property, successfully loaded.
 */
class LoadNetIncomeTotalsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.LoadNetIncomeTotalsSuccess;
    }
}
/**
 * Loading of net income totals failed.
 */
class LoadNetIncomeTotalsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.LoadNetIncomeTotalsFailure;
    }
}
/**
 * Add net income distribution.
 */
class AddNetIncomeDistribution {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.AddNetIncomeDistribution;
    }
}
/**
 * Update net income distribution.
 */
class UpdateNetIncomeDistribution {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.UpdateNetIncomeDistribution;
    }
}
/**
 * Remove net income distribution.
 */
class RemoveNetIncomeDistribution {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.RemoveNetIncomeDistribution;
    }
}
/**
 * Update net income distributions summary.
 */
class UpdateNetIncomeDistributionsSummary {
    constructor() {
        this.type = NetIncomeDistributionDataActionTypes.UpdateNetIncomeDistributionsSummary;
    }
}
/**
 * Set net income distributions selection.
 */
class SetNetIncomeDistributionsSelection {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.SetNetIncomeDistributionsSelection;
    }
}
/**
 * @description
 *
 * Set the  equity account to the distribution based on the index.
 */
class SetEquityAccountToNetIncomeDistribution {
    constructor(payload) {
        this.payload = payload;
        this.type = NetIncomeDistributionDataActionTypes.SetEquityAccountToNetIncomeDistribution;
    }
}
/**
 * @description
 *
 * Set the net Income DistributionStore to the default initial values.
 */
class ResetNetIncomeDistributions {
    constructor() {
        this.type = NetIncomeDistributionDataActionTypes.ResetNetIncomeDistributions;
    }
}

const netIncomeDistributionDataFeatureKey = 'netIncomeDistributionDataState';
const initialState$5 = {
    netIncomeDistributions: [],
    netIncomeTotalLoading: false,
    netIncomeTotalLoaded: false,
    netIncomeTotalLoadingFailed: false,
    adjustedBalanceTypeId: '',
    distributionSummary: {
        netIncomeTotal: 0,
        distributedPercentage: 0,
        distributedAmount: 0,
        remainingPercentage: 0,
        remainingAmount: 0
    }
};
/**
 * Updates the state based on the action and its payload.
 * @param state Initial State by default.
 * @param action NetIncomeDistributionDataActions
 */
function reducer$5(state = initialState$5, action) {
    switch (action.type) {
        case NetIncomeDistributionDataActionTypes.SetNetIncomeDistributions:
            return Object.assign(Object.assign({}, state), { netIncomeDistributions: action.payload.distributions });
        case NetIncomeDistributionDataActionTypes.LoadNetIncomeTotals:
            return Object.assign(Object.assign({}, state), { netIncomeTotalLoading: true, netIncomeTotalLoaded: false, netIncomeTotalLoadingFailed: false });
        case NetIncomeDistributionDataActionTypes.LoadNetIncomeTotalsSuccess:
            // Store in the local variable distributionSummary the values that are already in the store.
            const distributionSummary = Object.assign({}, state.distributionSummary);
            // Get the NetIncomeTotal based on the adjustedBalanceTypeId.
            const amountTotal = action.payload.netIncomeTotals.find(total => total.accountBalanceTypeId === action.payload.adjustedBalanceTypeId);
            // Calculate the total amount to distribute based on the amountTotal net value.
            const netIncomeTotal = amountTotal ? amountTotal.amountDebit - amountTotal.amountCredit : 0;
            // Assign the netIcomeTotal to distribute to the distribution summary totalNetIncomeAmount
            // that is required in the case: UpdateNetIncomeDistributionsSummary for future calculations.
            distributionSummary.netIncomeTotal = parseFloat((netIncomeTotal).toFixed(2));
            return Object.assign(Object.assign({}, state), { adjustedBalanceTypeId: action.payload.adjustedBalanceTypeId, netIncomeTotalLoading: false, netIncomeTotalLoaded: true, netIncomeTotalLoadingFailed: false, distributionSummary });
        case NetIncomeDistributionDataActionTypes.LoadNetIncomeTotalsFailure:
            return Object.assign(Object.assign({}, state), { netIncomeTotalLoading: false, netIncomeTotalLoaded: false, netIncomeTotalLoadingFailed: true });
        case NetIncomeDistributionDataActionTypes.AddNetIncomeDistribution:
            const addNetIncomeDistributions = [...state.netIncomeDistributions];
            addNetIncomeDistributions.unshift(action.payload.distribution);
            return Object.assign(Object.assign({}, state), { netIncomeDistributions: addNetIncomeDistributions });
        case NetIncomeDistributionDataActionTypes.UpdateNetIncomeDistribution:
            const updateNetIncomeDistributions = [...state.netIncomeDistributions];
            if (action.payload.index >= 0) {
                updateNetIncomeDistributions[action.payload.index] = action.payload.distribution;
            }
            return Object.assign(Object.assign({}, state), { netIncomeDistributions: updateNetIncomeDistributions });
        case NetIncomeDistributionDataActionTypes.RemoveNetIncomeDistribution:
            let removeNetIncomeDistributions = [...state.netIncomeDistributions];
            removeNetIncomeDistributions = removeNetIncomeDistributions.filter((distribution, index) => !action.payload.indexes.includes(index));
            return Object.assign(Object.assign({}, state), { netIncomeDistributions: removeNetIncomeDistributions });
        case NetIncomeDistributionDataActionTypes.UpdateNetIncomeDistributionsSummary:
            const summary = Object.assign({}, state.distributionSummary);
            const netIncomeDistributions = [...state.netIncomeDistributions];
            let totalDistributed = 0;
            let percentageDistributed = 0;
            netIncomeDistributions.forEach((distribution) => {
                totalDistributed += distribution.distributionAmount || 0;
                percentageDistributed += distribution.distributionPercentage || 0;
            });
            summary.distributedPercentage = percentageDistributed;
            summary.distributedAmount = parseFloat(totalDistributed.toFixed(2));
            summary.remainingPercentage = 100 - percentageDistributed;
            summary.remainingAmount = parseFloat((summary.netIncomeTotal - totalDistributed).toFixed(2));
            return Object.assign(Object.assign({}, state), { distributionSummary: summary });
        case NetIncomeDistributionDataActionTypes.SetNetIncomeDistributionsSelection:
            const setNetIncomeDistributionsSelection = state.netIncomeDistributions.map(distribution => {
                return Object.assign(Object.assign({}, distribution), { selected: action.payload.selection });
            });
            return Object.assign(Object.assign({}, state), { netIncomeDistributions: setNetIncomeDistributionsSelection });
        case NetIncomeDistributionDataActionTypes.SetEquityAccountToNetIncomeDistribution:
            const distributions = state.netIncomeDistributions.map((distribution, index) => {
                if (index === action.payload.index) {
                    return {
                        accountId: distribution.accountId,
                        distributionPercentage: distribution.distributionPercentage,
                        distributionAmount: distribution.distributionAmount,
                        yearEndCloseSettingId: distribution.yearEndCloseSettingId,
                        account: action.payload.equityAccount
                    };
                }
                return distribution;
            });
            return Object.assign(Object.assign({}, state), { netIncomeDistributions: distributions });
        case NetIncomeDistributionDataActionTypes.ResetNetIncomeDistributions:
            return Object.assign({}, initialState$5);
        default:
            return state;
    }
}

var YearEndCloseInputsActionTypes;
(function (YearEndCloseInputsActionTypes) {
    YearEndCloseInputsActionTypes["SetYearEndCloseInputs"] = "[BMYEC YearEndCloseInputs] Set YearEndCloseInputs";
})(YearEndCloseInputsActionTypes || (YearEndCloseInputsActionTypes = {}));
/**
 * Set the Year End Close Inputs fiscal year and Contact display name on the payload object.
 */
class SetYearEndCloseInputs {
    constructor(payload) {
        this.payload = payload;
        this.type = YearEndCloseInputsActionTypes.SetYearEndCloseInputs;
    }
}

const yearEndCloseInputsFeatureKey = 'yearEndCloseInputs';
const initialState$4 = {
    fiscalYearNumber: 0,
    contactDisplayName: '',
    ownerId: ''
};
/**
 * Updates the state based on the action and its payload.
 *
 * @param state State object with default initial values.
 * @param action The action that will define what properties will be set and/or updated on the store
 * taken from the payload property.
 */
function reducer$4(state = initialState$4, action) {
    switch (action.type) {
        case YearEndCloseInputsActionTypes.SetYearEndCloseInputs:
            return Object.assign(Object.assign({}, state), { fiscalYearNumber: action.payload.fiscalYearNumber, contactDisplayName: action.payload.contactDisplayName, ownerId: action.payload.ownerId });
        default:
            return state;
    }
}

var YearEndCloseSettingActionTypes;
(function (YearEndCloseSettingActionTypes) {
    YearEndCloseSettingActionTypes["LoadYearEndCloseSettings"] = "[BMYEC YearEndCloseSetting] Load YearEndCloseSettings";
    YearEndCloseSettingActionTypes["LoadYearEndCloseSettingsSuccess"] = "[BMYEC YearEndCloseSetting] Load YearEndCloseSettings Success";
    YearEndCloseSettingActionTypes["LoadYearEndCloseSettingsFailure"] = "[BMYEC YearEndCloseSetting] Load YearEndCloseSettings Failure";
    YearEndCloseSettingActionTypes["UpdateYearEndCloseSettings"] = "[BMYEC YearEndCloseSetting] Update YearEndCloseSettings";
    YearEndCloseSettingActionTypes["UpdateZeroOutAccountBalances"] = "[BMYEC YearEndCloseSetting] Update ZeroOutAccountBalances";
    YearEndCloseSettingActionTypes["LoadDefaultYearEndCloseSettings"] = "[BMYEC YearEndCLoseSettings] Load Default YearEndCloseSettings";
})(YearEndCloseSettingActionTypes || (YearEndCloseSettingActionTypes = {}));
/**
 * @description
 *
 * The load year end close settings action.
 */
class LoadYearEndCloseSettings {
    constructor(payload) {
        this.payload = payload;
        this.type = YearEndCloseSettingActionTypes.LoadYearEndCloseSettings;
    }
}
/**
 * @description
 *
 * The load year end close settings success action.
 */
class LoadYearEndCloseSettingsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = YearEndCloseSettingActionTypes.LoadYearEndCloseSettingsSuccess;
    }
}
/**
 * @description
 *
 * The load year end close settings failure action.
 */
class LoadYearEndCloseSettingsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = YearEndCloseSettingActionTypes.LoadYearEndCloseSettingsFailure;
    }
}
/**
 * @description
 *
 * The update year end close settings action.
 */
class UpdateYearEndCloseSettings {
    constructor(payload) {
        this.payload = payload;
        this.type = YearEndCloseSettingActionTypes.UpdateYearEndCloseSettings;
    }
}
/**
 * @description
 *
 * The update year end close setting enable zero out account balances flag.
 */
class UpdateZeroOutAccountBalances {
    constructor(payload) {
        this.payload = payload;
        this.type = YearEndCloseSettingActionTypes.UpdateZeroOutAccountBalances;
    }
}
/**
 * @description
 *
 * Loads the default values of the Year End Close Settings.
 */
class LoadDefaultYearEndCloseSettings {
    constructor(payload) {
        this.payload = payload;
        this.type = YearEndCloseSettingActionTypes.LoadDefaultYearEndCloseSettings;
    }
}

const yearEndCloseSettingFeatureKey = 'yearEndCloseSettingState';
const initialState$3 = {
    yearEndCloseSetting: undefined,
    yearEndCloseSettingLoading: false,
    yearEndCloseSettingLoaded: false,
    yearEndCloseSettingFailed: false,
    yearEndCloseSettingRetried: false
};
/**
 * @description
 *
 * The load year end close settings reducer.
 *
 * @param state The initial state.
 * @param action The year end close settings action.
 *
 * @returns the up to date year end close settings state.
 */
function reducer$3(state = initialState$3, action) {
    switch (action.type) {
        case YearEndCloseSettingActionTypes.LoadYearEndCloseSettings:
            return Object.assign(Object.assign({}, state), { yearEndCloseSettingLoading: true, yearEndCloseSettingLoaded: false, yearEndCloseSettingFailed: false, yearEndCloseSettingRetried: action.payload.retried });
        case YearEndCloseSettingActionTypes.LoadYearEndCloseSettingsSuccess:
            return Object.assign(Object.assign({}, state), { yearEndCloseSetting: action.payload.data, yearEndCloseSettingLoading: false, yearEndCloseSettingLoaded: true, yearEndCloseSettingFailed: false });
        case YearEndCloseSettingActionTypes.LoadYearEndCloseSettingsFailure:
            return Object.assign(Object.assign({}, state), { yearEndCloseSetting: action.payload.defaultSettings, yearEndCloseSettingLoading: false, yearEndCloseSettingLoaded: state.yearEndCloseSettingRetried, yearEndCloseSettingFailed: true });
        case YearEndCloseSettingActionTypes.UpdateYearEndCloseSettings:
            return Object.assign(Object.assign({}, state), { yearEndCloseSetting: action.payload.updatedSettings });
        case YearEndCloseSettingActionTypes.UpdateZeroOutAccountBalances:
            return Object.assign(Object.assign({}, state), { yearEndCloseSetting: Object.assign(Object.assign({}, state.yearEndCloseSetting), { enableZeroOutAccountBalances: action.payload.enableZeroOutAccountBalances }) });
        case YearEndCloseSettingActionTypes.LoadDefaultYearEndCloseSettings:
            return Object.assign(Object.assign({}, state), { yearEndCloseSetting: action.payload.defaultSettings, yearEndCloseSettingLoading: false, yearEndCloseSettingLoaded: true, yearEndCloseSettingFailed: false, yearEndCloseSettingRetried: false });
        default:
            return state;
    }
}

var AccountGroupsActionTypes;
(function (AccountGroupsActionTypes) {
    AccountGroupsActionTypes["LoadAccountGroups"] = "[BMYEC Accounting] Load AccountGroups";
    AccountGroupsActionTypes["LoadAccountGroupsSuccess"] = "[BMYEC Accounting] Load AccountGroups Success";
    AccountGroupsActionTypes["LoadAccountGroupsFailure"] = "[BMYEC Accounting] Load AccountGroups Failure";
})(AccountGroupsActionTypes || (AccountGroupsActionTypes = {}));
/**
 * Load account groups by ownerId.
 */
class LoadAccountGroups {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupsActionTypes.LoadAccountGroups;
    }
}
/**
 * Account groups successfully loaded, sent in data property with Account Balance Types array.
 */
class LoadAccountGroupsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupsActionTypes.LoadAccountGroupsSuccess;
    }
}
/**
 * Loading of account groups failed returning the error property.
 */
class LoadAccountGroupsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupsActionTypes.LoadAccountGroupsFailure;
    }
}

const accountGroupsFeatureKey = 'accountGroupState';
const initialState$2 = {
    accountGroups: [],
    accountGroupsLoading: false,
    accountGroupsLoaded: false,
    accountGroupsLoadingFailed: false
};
/**
 * Updates the state based on the action and its payload.
 *
 * @param state State object with default initial values.
 * @param action The action that will define what properties will be set and/or updated on the store
 * taken from the payload.data property.
 */
function reducer$2(state = initialState$2, action) {
    switch (action.type) {
        case AccountGroupsActionTypes.LoadAccountGroups:
            return Object.assign(Object.assign({}, state), { accountGroups: [], accountGroupsLoading: true, accountGroupsLoaded: false, accountGroupsLoadingFailed: false });
        case AccountGroupsActionTypes.LoadAccountGroupsSuccess:
            return Object.assign(Object.assign({}, state), { accountGroups: action.payload.data, accountGroupsLoading: false, accountGroupsLoaded: true, accountGroupsLoadingFailed: false });
        case AccountGroupsActionTypes.LoadAccountGroupsFailure:
            return Object.assign(Object.assign({}, state), { accountGroupsLoading: false, accountGroupsLoaded: false, accountGroupsLoadingFailed: true });
        default:
            return state;
    }
}

var CategoryNodeOptionsActionTypes;
(function (CategoryNodeOptionsActionTypes) {
    CategoryNodeOptionsActionTypes["LoadCategoryNodeOptions"] = "[BMYEC Accounting] Load CategoryNodeOptions";
    CategoryNodeOptionsActionTypes["LoadCategoryNodeOptionsSuccess"] = "[BMYEC Accounting] Load CategoryNodeOptions Success";
    CategoryNodeOptionsActionTypes["LoadCategoryNodeOptionsFailure"] = "[BMYEC Accounting] Load CategoryNodeOptions Failure";
})(CategoryNodeOptionsActionTypes || (CategoryNodeOptionsActionTypes = {}));
/**
 * Load category node options by ownerId.
 */
class LoadCategoryNodeOptions {
    constructor(payload) {
        this.payload = payload;
        this.type = CategoryNodeOptionsActionTypes.LoadCategoryNodeOptions;
    }
}
/**
 * category node options successfully loaded, sent in data property with Account Balance Types array.
 */
class LoadCategoryNodeOptionsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = CategoryNodeOptionsActionTypes.LoadCategoryNodeOptionsSuccess;
    }
}
/**
 * Loading of category node options failed returning the error property.
 */
class LoadCategoryNodeOptionsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = CategoryNodeOptionsActionTypes.LoadCategoryNodeOptionsFailure;
    }
}

const categoryNodeOptionsFeatureKey = 'categoryNodeOptionsState';
const ɵ0$8 = option => option.accountGroupId;
const adapter = createEntityAdapter({
    selectId: ɵ0$8
});
const initialState$1 = adapter.getInitialState();
/**
 * Updates the state based on the action and its payload.
 *
 * @param state State object with default initial values.
 * @param action The action that will define what properties will be set and/or updated on the store
 * taken from the payload.data property.
 */
function reducer$1(state = initialState$1, action) {
    switch (action.type) {
        case CategoryNodeOptionsActionTypes.LoadCategoryNodeOptions:
            return adapter.upsertOne({
                categoryNodeOptions: [],
                categoryNodeOptionsLoading: true,
                categoryNodeOptionsLoaded: false,
                categoryNodeOptionsLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case CategoryNodeOptionsActionTypes.LoadCategoryNodeOptionsSuccess:
            return adapter.upsertOne({
                categoryNodeOptions: action.payload.categoryNodeOptions,
                categoryNodeOptionsLoading: false,
                categoryNodeOptionsLoaded: true,
                categoryNodeOptionsLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case CategoryNodeOptionsActionTypes.LoadCategoryNodeOptionsFailure:
            return adapter.upsertOne({
                categoryNodeOptions: [],
                categoryNodeOptionsLoading: false,
                categoryNodeOptionsLoaded: false,
                categoryNodeOptionsLoadingFailed: true,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        default:
            return state;
    }
}
// get the selectors
const { selectEntities } = adapter.getSelectors();
// select the dictionary of category node option entities
const selectCategoryNodeMap = selectEntities;

var FiscalYearActionTypes;
(function (FiscalYearActionTypes) {
    FiscalYearActionTypes["LoadFiscalYears"] = "[BMYEC FiscalYear] Load FiscalYears";
    FiscalYearActionTypes["LoadFiscalYearsSuccess"] = "[BMYEC FiscalYear] Load FiscalYears Success";
    FiscalYearActionTypes["LoadFiscalYearsFailure"] = "[BMYEC FiscalYear] Load FiscalYears Failure";
})(FiscalYearActionTypes || (FiscalYearActionTypes = {}));
/**
 * @description
 *
 * Load Fiscal Years connected to ownerId.
 *
 */
class LoadFiscalYears {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYears;
    }
}
/**
 * @description
 *
 * Fiscal Years successfully loaded, sent in data property with FiscalYear array.
 *
 */
class LoadFiscalYearsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYearsSuccess;
    }
}
/**
 * Fiscal Years loading failed.
 */
class LoadFiscalYearsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYearsFailure;
    }
}

const fiscalYearFeatureKey = 'fiscalYearState';
const initialState = {
    fiscalYears: [],
    fiscalYearsLoading: false,
    fiscalYearsLoaded: false,
    fiscalYearsLoadingFailed: false,
};
/**
 * Updates the Fiscal Year state based on the action and its payload.
 *
 * @param state State object with default initial values.
 * @param action The action that will define what properties will be set and/or updated on the store
 * taken from the payload property.
 */
function reducer(state = initialState, action) {
    switch (action.type) {
        case FiscalYearActionTypes.LoadFiscalYears:
            return Object.assign(Object.assign({}, state), { fiscalYears: [], fiscalYearsLoading: true, fiscalYearsLoaded: false, fiscalYearsLoadingFailed: false });
        case FiscalYearActionTypes.LoadFiscalYearsSuccess:
            return Object.assign(Object.assign({}, state), { fiscalYears: action.payload.data, fiscalYearsLoading: false, fiscalYearsLoaded: true, fiscalYearsLoadingFailed: false });
        case FiscalYearActionTypes.LoadFiscalYearsFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearsLoading: false, fiscalYearsLoaded: false, fiscalYearsLoadingFailed: true });
        default:
            return state;
    }
}

const yearEndCloseStateFeatureKey = 'yearEndCloseState';
const getYearEndCloseState = createFeatureSelector(yearEndCloseStateFeatureKey);
const reducers = {
    accountBalanceTypeState: reducer$7,
    equityAccountState: reducer$6,
    netIncomeDistributionDataState: reducer$5,
    yearEndCloseInputsState: reducer$4,
    yearEndCloseSettingsState: reducer$3,
    accountGroupsState: reducer$2,
    categoryNodeOptionsState: reducer$1,
    fiscalYearState: reducer
};
const metaReducers = [];

const ɵ0$7 = (state) => state.yearEndCloseSettingsState;
/**
 * @description
 *
 * The get year end close settings state selector.
 *
 * @returns the year end close settings.
 */
const getYearEndCloseSettingState = createSelector(getYearEndCloseState, ɵ0$7);
const ɵ1$7 = (state) => state.yearEndCloseSetting;
/**
 * @description
 *
 * The get year end close settings selector.
 *
 * @returns the year end close settings.
 */
const getYearEndCloseSetting = createSelector(getYearEndCloseSettingState, ɵ1$7);
const ɵ2$5 = (state) => state.yearEndCloseSettingLoading;
/**
 * @description
 *
 * The get year end close settings loading selector.
 *
 * @returns the year end close settings loading.
 */
const getYearEndCloseSettingLoading = createSelector(getYearEndCloseSettingState, ɵ2$5);
const ɵ3$4 = (state) => state.yearEndCloseSettingLoaded;
/**
 * @description
 *
 * The get year end close settings loaded selector.
 *
 * @returns the year end close settings loaded.
 */
const getYearEndCloseSettingLoaded = createSelector(getYearEndCloseSettingState, ɵ3$4);
const ɵ4$4 = (state) => state.yearEndCloseSettingFailed;
/**
 * @description
 *
 * The get year end close settings loading failed selector.
 *
 * @returns the year end close settings loading failed.
 */
const getYearEndCloseSettingLoadingFailed = createSelector(getYearEndCloseSettingState, ɵ4$4);

const ɵ0$6 = (state) => state.yearEndCloseInputsState;
/**
 * Returns the YearEndCloseInputState.
 */
const getYearEndCloseInputsState = createSelector(getYearEndCloseState, ɵ0$6);
const ɵ1$6 = (state) => state.fiscalYearNumber;
/**
 * Returns the Fiscal Year Number.
 */
const getFiscalYearNumber = createSelector(getYearEndCloseInputsState, ɵ1$6);
const ɵ2$4 = (state) => state.contactDisplayName;
/**
 * Returns the Contact Display Name.
 */
const getContactDisplayName = createSelector(getYearEndCloseInputsState, ɵ2$4);

class BmyecAlertService {
    constructor(translateService) {
        this.translateService = translateService;
        this.onAlertAdded = new EventEmitter();
    }
    addAlert(type, message) {
        const option = {
            type,
            msg: this.translateService.instant(message.key, message.params),
            closeable: true
        };
        this.onAlertAdded.emit(option);
    }
    /**
     * Adds danger alert.
     * @param message The message.
     */
    addDangerAlert(message) {
        this.addAlert('danger', message);
    }
}
BmyecAlertService.ɵfac = function BmyecAlertService_Factory(t) { return new (t || BmyecAlertService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService)); };
BmyecAlertService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BmyecAlertService_Factory() { return new BmyecAlertService(i0.ɵɵinject(i1.TranslateService)); }, token: BmyecAlertService, providedIn: "root" });
BmyecAlertService.ctorParameters = () => [
    { type: TranslateService }
];

class BmyecGridValidatorService {
    /**
     * @description
     *
     * Creates an instance of bmyec toolbar service.
     *
     * @param translateService the translation service.
     */
    constructor(translateService, bmyecAlertService) {
        this.translateService = translateService;
        this.bmyecAlertService = bmyecAlertService;
        this.isGridValid = false;
        this.isDirtyGrid$ = new BehaviorSubject(false);
    }
    /**
     * @description
     *
     * Validates grid columns (amount, percentage, equity account).
     *
     * @returns whether the grid is valid or not.
     */
    validateGrid() {
        this.isGridValid = true;
        // If the net income total is zero, it must be allowed to close year
        // without doing any grid validation.
        if (this.distributionSummary.netIncomeTotal === 0) {
            return this.isGridValid;
        }
        for (const distribution of this.gridCollectionData) {
            this.validateDistributionAmount(distribution);
            this.validateDistributionPercentage(distribution);
            this.validateEquityAccount(distribution);
            if (!this.isGridValid) {
                this.bmyecAlertService.addDangerAlert({ key: 'bmyec_invalid_grid_error_alert' });
                break;
            }
        }
        this.validateTotalAmountDistributed();
        if (!this.isGridValid) {
            this.isGridValid = false;
            this.isDirtyGrid$.next(true);
        }
        return this.isGridValid;
    }
    /**
     * @description
     *
     * Validates distribution percentage on a distribution item having amount or account.
     *
     * @param distribution The distribution.
     * @returns A string message if is invalid, null if valid.
     */
    validateDistributionPercentage(distribution) {
        if (distribution.distributionPercentage === null
            && (distribution.distributionAmount !== null || distribution.account.id)) {
            this.isGridValid = false;
            return this.translateService.instant('bmyec_enter_percentage');
        }
        return null;
    }
    /**
     * @description
     *
     * Validates distribution amount on a distribution item having percentage or account.
     *
     * @param distribution The distribution.
     * @returns A string message if is invalid, null if valid.
     */
    validateDistributionAmount(distribution) {
        if (distribution.distributionAmount === null
            && (distribution.distributionPercentage !== null || distribution.account.id)) {
            this.isGridValid = false;
            return this.translateService.instant('bmyec_enter_amount');
        }
        return null;
    }
    /**
     * @description
     *
     * Validates distribution account on a distribution item having amount or percentage.
     *
     * @param distribution The distribution.
     * @returns A string message if is invalid, null if valid.
     */
    validateEquityAccount(distribution) {
        if (!distribution.account.id
            && (distribution.distributionPercentage !== null
                || distribution.distributionAmount !== null)) {
            this.isGridValid = false;
            return this.translateService.instant('bmyec_choose_equity_account');
        }
        return null;
    }
    /**
     * @description
     *
     * Returns the dirty grid as observable.
     *
     * @returns The observable.
     */
    getIsDirtyGridObservable() {
        return this.isDirtyGrid$.asObservable();
    }
    /**
     * @description
     *
     * Sets the grid collection data.
     *
     * @param gridData The grid data.
     */
    setGridCollectionData(gridData) {
        this.gridCollectionData = gridData;
    }
    /**
     * @description
     *
     * @param distributionSummary Contains the updated distribution summary calculated automatically from the grid information.
     */
    setDistributionSummaryData(distributionSummary) {
        this.distributionSummary = distributionSummary;
    }
    /**
     * @description
     *
     * Validates the amount distributed and display the alert based on if it is over or under distributed.
     */
    validateTotalAmountDistributed() {
        // totalUndistributed is the difference between absolute values of netIncomeTotal and distributedAmount,
        // used to know if the amount was under/over distributed regardless if the netIncome is positive or negative
        const totalUndistributed = Math.abs(this.distributionSummary.netIncomeTotal) - Math.abs(this.distributionSummary.distributedAmount);
        if ((totalUndistributed === 0 && this.distributionSummary.netIncomeTotal !== this.distributionSummary.distributedAmount) ||
            (totalUndistributed > 0)) {
            this.isGridValid = false;
            this.bmyecAlertService.addDangerAlert({ key: 'bmyec_distribution_amount_not_fully_distributed' });
        }
        else if (totalUndistributed < 0) {
            this.isGridValid = false;
            this.bmyecAlertService.addDangerAlert({ key: 'bmyec_distribution_amount_exceded' });
        }
    }
    /**
     * @description
     *
     * Sets the grid observable false making the grid not dirty.
     */
    setGridAsPristine() {
        this.isDirtyGrid$.next(false);
    }
}
BmyecGridValidatorService.ɵfac = function BmyecGridValidatorService_Factory(t) { return new (t || BmyecGridValidatorService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService), ɵngcc0.ɵɵinject(BmyecAlertService)); };
BmyecGridValidatorService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BmyecGridValidatorService_Factory() { return new BmyecGridValidatorService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(BmyecAlertService)); }, token: BmyecGridValidatorService, providedIn: "root" });
BmyecGridValidatorService.ctorParameters = () => [
    { type: TranslateService },
    { type: BmyecAlertService }
];

class BmyecEventQueueService {
    constructor() {
        this.focusCloseButton = new Subject();
    }
    /**
     * @description
     * Sets wether to focus on close button or not.
     *
     * @param focus wether to focus close button.
     */
    setFocusCloseButton(focus) {
        this.focusCloseButton.next(focus);
    }
    /**
     * @description
     * Clears focus close button event.
     */
    clearFocusCloseButton() {
        this.focusCloseButton.next();
    }
    /**
     * @description
     * Gets the focus close button observable.
     *
     * @returns the focus close button observable.
     */
    getFocusCloseButton() {
        return this.focusCloseButton.asObservable();
    }
}
BmyecEventQueueService.ɵfac = function BmyecEventQueueService_Factory(t) { return new (t || BmyecEventQueueService)(); };
BmyecEventQueueService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BmyecEventQueueService_Factory() { return new BmyecEventQueueService(); }, token: BmyecEventQueueService, providedIn: "root" });

const ɵ0$5 = (state) => state.fiscalYearState;
/**
 * @description
 *
 * Selector for the whole Fiscal Year state.
 */
const getFiscalYearState = createSelector(getYearEndCloseState, ɵ0$5);
const ɵ1$5 = (state) => state.fiscalYears;
/**
 * @description
 *
 * Selector that returns the Fiscal Years array from the state.
 */
const getFiscalYears = createSelector(getFiscalYearState, ɵ1$5);
const ɵ2$3 = (years, selectorProps) => years.find(year => year.id === selectorProps.fiscalYearId);
/**
 * @description
 *
 * Selector that returns the Fiscal Year by given fiscalYearId.
 */
const getFiscalYearById = createSelector(getFiscalYears, ɵ2$3);
const ɵ3$3 = (fiscalYearSelected) => {
    if (fiscalYearSelected === undefined) {
        return undefined;
    }
    return fiscalYearSelected.periods[fiscalYearSelected.periods.length - 1];
};
/**
 * @description
 *
 * Selector that returns the Fiscal Year by given fiscalYearId.
 */
const getFiscalYearLastPeriod = createSelector(getFiscalYearById, ɵ3$3);
const ɵ4$3 = (years, selectorProps) => getFiscalYearById(years, selectorProps), ɵ5$3 = (years, currentFiscalYear) => currentFiscalYear !== undefined ? years.find(year => year.sequenceNumber === currentFiscalYear.sequenceNumber - 1) : undefined;
/**
 * @description
 *
 * Selector that returns the previous Fiscal Year for a given fiscalYearId.
 * Returns undefined if the given fiscal year doesn't exist or there is no previous fiscal year.
 */
const getPreviousFiscalYear = createSelector(getFiscalYears, ɵ4$3, ɵ5$3);

const ɵ0$4 = (state) => state.equityAccountState;
/**
 * Returns the EquityAccountState.
 */
const getEquityAccountState = createSelector(getYearEndCloseState, ɵ0$4);
const ɵ1$4 = (state) => state.equityAccounts;
/**
 * Returns the EquityAccounts array.
 */
const getEquityAccounts = createSelector(getEquityAccountState, ɵ1$4);
const ɵ2$2 = (state) => state.equityAccountsLoading;
/**
 * Returns the boolean EquityAccountsLoading property.
 */
const getEquityAccountsLoading = createSelector(getEquityAccountState, ɵ2$2);
const ɵ3$2 = (state) => state.equityAccountsLoaded;
/**
 * Returns the boolean EquityAccountsLoaded property.
 */
const getEquityAccountsLoaded = createSelector(getEquityAccountState, ɵ3$2);
const ɵ4$2 = (state) => state.equityAccountsLoadingFailed;
/**
 * Returns the boolean EquityAccountsLoadingFailed property.
 */
const getEquityAccountsLoadingFailed = createSelector(getEquityAccountState, ɵ4$2);
const ɵ5$2 = (state) => state.selectedEquityAccounts;
/**
 * Returns the selected equity accounts from state.
 */
const getSelectedEquityAccounts = createSelector(getEquityAccountState, ɵ5$2);
const ɵ6$1 = (equityAccounts, selectedEquityAccounts) => {
    return equityAccounts.filter((account) => !selectedEquityAccounts.includes(account.id))
        .sort((a, b) => a.displayString.localeCompare(b.displayString));
};
/**
 * Returns the available EquityAccounts.
 */
const getAvailableEquityAccounts = createSelector(getEquityAccounts, getSelectedEquityAccounts, ɵ6$1);
const ɵ7 = (state) => { var _a; return ((_a = state.equityAccounts) === null || _a === void 0 ? void 0 : _a.length) > 0; };
/**
 * Returns true if there are equity account loaded in the store, false if there are no equity acounts.
 */
const getHasEquityAccounts = createSelector(getEquityAccountState, ɵ7);

const ɵ0$3 = (state) => state.netIncomeDistributionDataState;
/**
 * Returns the netIncomeDistributionDataState.
 */
const getNetIncomeDistributionDataState = createSelector(getYearEndCloseState, ɵ0$3);
const ɵ1$3 = (state) => state.netIncomeDistributions;
/**
 * Returns the netIncomeDistribution stored in the state.
 */
const getNetIncomeDistributions = createSelector(getNetIncomeDistributionDataState, ɵ1$3);
const ɵ2$1 = (state) => state.distributionSummary.netIncomeTotal;
/**
 * Returns the netIncomeTotal stored in the state.
 */
const getNetIncomeTotal = createSelector(getNetIncomeDistributionDataState, ɵ2$1);
const ɵ3$1 = (state) => state.netIncomeTotalLoading;
/**
 * Returns the netIncomeTotalLoading stored in the state.
 */
const getNetIncomeTotalLoading = createSelector(getNetIncomeDistributionDataState, ɵ3$1);
const ɵ4$1 = (state) => state.netIncomeTotalLoaded;
/**
 * Returns the netIncomeTotalLoaded stored in the state.
 */
const getNetIncomeTotalLoaded = createSelector(getNetIncomeDistributionDataState, ɵ4$1);
const ɵ5$1 = (state) => state.netIncomeTotalLoadingFailed;
/**
 * Returns the netIncomeTotalLoadingFailed stored in the state.
 */
const getNetIncomeTotalLoadingFailed = createSelector(getNetIncomeDistributionDataState, ɵ5$1);
const ɵ6 = (state) => state.distributionSummary;
/**
 * Returns the NetIncomeDistributionsSummary stored in the state
 */
const getNetIncomeDistributionSummary = createSelector(getNetIncomeDistributionDataState, ɵ6);

class BmyecYearEndCloseModalComponent {
    /**
     * @description
     *
     * Creates an instance of bmyec modal component.
     *
     * @param modalInstance the modal instance.
     * @param store the year end close state.
     * @param bmyecGridValidatorService the grid validator service.
     * @param bmyecAlertService the alert service.
     * @param bmyecEventQueueService the queue service.
     *
     */
    constructor(modalInstance, store, bmyecGridValidatorService, bmyecAlertService, bmyecEventQueueService) {
        this.modalInstance = modalInstance;
        this.store = store;
        this.bmyecGridValidatorService = bmyecGridValidatorService;
        this.bmyecAlertService = bmyecAlertService;
        this.bmyecEventQueueService = bmyecEventQueueService;
        this.alerts = [];
        this.subscription$ = new Subject();
        this.hasEquityAccounts = false;
    }
    /**
     * @description
     *
     * Cancel callback for the modal instance.
     */
    cancel() {
        this.modalInstance.dismiss({});
    }
    /**
     * @description
     *
     * Save callback for the modal instance.
     */
    save() {
        if (this.yearEndCloseSettings.enableZeroOutAccountBalances) {
            this.modalInstance.close();
        }
        else if (!this.hasEquityAccounts && this.netIncomeTotal !== 0) {
            this.bmyecAlertService.addDangerAlert({ key: 'bmyec_distribution_amount_not_fully_distributed' });
        }
        else if (this.bmyecGridValidatorService.validateGrid()) {
            this.modalInstance.close();
        }
    }
    /**
     * @description
     *
     * Updates year end close setting store
     */
    zeroOutBalanceChanged(newValue) {
        this.yearEndCloseSettings.enableZeroOutAccountBalances = newValue;
        this.store.dispatch(new UpdateZeroOutAccountBalances({
            enableZeroOutAccountBalances: this.yearEndCloseSettings.enableZeroOutAccountBalances
        }));
    }
    /**
     * @description
     *
     * Runs when the component gets initialized.
     */
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.pipe(select(getHasEquityAccounts))
                .pipe(takeUntil(this.subscription$))
                .subscribe(hasEquityAccounts => {
                this.hasEquityAccounts = hasEquityAccounts;
            });
            this.store.pipe(select(getNetIncomeTotal))
                .pipe(takeUntil(this.subscription$))
                .subscribe(netIncomeTotal => this.netIncomeTotal = netIncomeTotal);
            this.store.pipe(select(getYearEndCloseSettingState), first(setting => setting.yearEndCloseSettingLoaded))
                .toPromise()
                .then(yearEndCloseSettingState => {
                this.yearEndCloseSettings = Object.assign({}, yearEndCloseSettingState.yearEndCloseSetting);
                this.zeroOutBalanceChanged(this.yearEndCloseSettings.enableZeroOutAccountBalances);
            });
            this.store.pipe(select(getYearEndCloseInputsState), first(inputState => inputState !== undefined))
                .toPromise()
                .then(inputState => {
                this.contactDisplayName = inputState.contactDisplayName;
            });
            // Get the fiscal year end date to display on header once the fiscal years are loaded.
            this.store.pipe(select(getFiscalYearState), first(fiscalYears => fiscalYears.fiscalYearsLoaded === true))
                .toPromise()
                .then(_fiscalYearsState => {
                this.store.pipe(select(getFiscalYearById, { fiscalYearId: this.yearEndCloseSettings.fiscalYearId }))
                    .pipe(takeUntil(this.subscription$))
                    .subscribe(fiscalYear => this.fiscalYearEndDate = fiscalYear.endDate);
            });
            this.bmyecAlertService.onAlertAdded
                .pipe(takeUntil(this.subscription$))
                .subscribe((alert) => this.alerts.push(alert));
            // Subscribe to event queue service to check if the close button needs to be focused.
            // Grid component uses this service to notify the component to focus the button.
            this.bmyecEventQueueService.getFocusCloseButton()
                .pipe(takeUntil(this.subscription$))
                .subscribe(focusCloseButton => this.onGridTabOutEventHandler(focusCloseButton));
        });
    }
    /**
     * Handles the action when the grid is tab out.
     * @param focusCloseButton wether to select the close button.
     */
    onGridTabOutEventHandler(focusCloseButton) {
        if (focusCloseButton) {
            this.closeYearButton.nativeElement.focus();
        }
    }
    /**
     * executes when the component is destroyed.
     */
    ngOnDestroy() {
        if (this.subscription$) {
            this.subscription$.next();
            this.subscription$.complete();
        }
    }
}
BmyecYearEndCloseModalComponent.ɵfac = function BmyecYearEndCloseModalComponent_Factory(t) { return new (t || BmyecYearEndCloseModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Store), ɵngcc0.ɵɵdirectiveInject(BmyecGridValidatorService), ɵngcc0.ɵɵdirectiveInject(BmyecAlertService), ɵngcc0.ɵɵdirectiveInject(BmyecEventQueueService)); };
BmyecYearEndCloseModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BmyecYearEndCloseModalComponent, selectors: [["bmyec-modal"]], viewQuery: function BmyecYearEndCloseModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.closeYearButton = _t.first);
    } }, decls: 25, vars: 25, consts: [[3, "items"], ["id", "bmyec-modal-header", 1, "modal-header", "bmyec-workspace-modal-header", "bmyec-workspace-padding"], [1, "row"], [1, "col-md-4", "col-sm-4", "hidden-xs"], [1, "modal-title"], [1, "col-md-8", "col-sm-8", "col-xs-12", "text-right"], ["type", "button", "id", "bmyec-year-end-close-main-close-year", "data-qe-id", "bmyec-year-end-close-main-close-year", 1, "btn", "btn-primary", "knowledge-bold", 3, "click"], ["bmyecYearEndCloseMainCloseYear", ""], ["type", "button", "id", "bmyec-year-end-close-main-modal-cancel", "data-qe-id", "bmyec-year-end-close-main-modal-cancel", 1, "btn", "btn-outline-primary", 3, "click"], [1, "modal-workspace-body"], [1, "bmyec-form-header"], ["class", "row mr-2", 4, "ngIf"], [1, "row", "mr-2"], [1, "col-md-12", "col-sm-12"], [1, "card"], [1, "card-header"], [1, "card-body"], [1, "col-md-4", "col-sm-4", "bmyec-bento-toggle"], ["for", "bmyec-clear-balances-toggle", 1, "bmyec-form-label"], ["data-qe-id", "bmyec-main-toggle", 1, "bmyec-clear-balances-toggle", 3, "ngModel", "ngModelChange"], [1, "col-md-12"], [4, "ngIf"]], template: function BmyecYearEndCloseModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "bento-alert", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "h1", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 5)(8, "button", 6, 7);
        ɵngcc0.ɵɵlistener("click", function BmyecYearEndCloseModalComponent_Template_button_click_8_listener() { return ctx.save(); });
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "button", 8);
        ɵngcc0.ɵɵlistener("click", function BmyecYearEndCloseModalComponent_Template_button_click_12_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(15, "div", 9)(16, "div", 10)(17, "h2");
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵpipe(20, "bmyecFormatDatePipe");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "span");
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(24, BmyecYearEndCloseModalComponent_div_24_Template, 16, 8, "div", 11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.alerts);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(6, 7, "bmyec_year_end_close_modal_contact_display_name", ɵngcc0.ɵɵpureFunction1(21, _c1, ctx.contactDisplayName)), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 10, "bmyec_year_end_close_modal_close_year_save"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 12, "bmyec_year_end_close_modal_close_year_cancel"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(19, 14, "bmyec_year_end_close_modal_fiscal_year_for", ɵngcc0.ɵɵpureFunction1(23, _c1, ɵngcc0.ɵɵpipeBind1(20, 17, ctx.fiscalYearEndDate))));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(23, 19, "bmyec_manage_year_end_close_settings"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.yearEndCloseSettings !== undefined);
    } }, directives: function () { return [ɵngcc4.BentoAlertComponent, ɵngcc4.BentoFocusMonitorDirective, ɵngcc5.NgIf, ɵngcc4.BentoToggleComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, BmyecNetIncomeDistributionComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe, BmyecFormatDatePipe]; }, styles: [""] });
BmyecYearEndCloseModalComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: Store },
    { type: BmyecGridValidatorService },
    { type: BmyecAlertService },
    { type: BmyecEventQueueService }
];
BmyecYearEndCloseModalComponent.propDecorators = {
    closeYearButton: [{ type: ViewChild, args: ['bmyecYearEndCloseMainCloseYear',] }]
};

const ɵ0$2 = (state) => state.accountBalanceTypeState;
/**
 * Returns the AccountBalanceTypeState.
 */
const getAccountBalanceTypeState = createSelector(getYearEndCloseState, ɵ0$2);
const ɵ1$2 = (state) => state.accountBalanceTypes;
/**
 * Returns the AccountBalanceTypes array.
 */
const getAccountBalanceTypes = createSelector(getAccountBalanceTypeState, ɵ1$2);
const ɵ2 = (state) => {
    const adjusted = state.accountBalanceTypes.find(type => {
        return type.description === AccountBalanceTypeDescriptions.Adjusted;
    });
    return adjusted;
};
/**
 * Returns the Adjusted balance type enum.
 */
const getAdjustedBalanceType = createSelector(getAccountBalanceTypeState, ɵ2);
const ɵ3 = (state) => state.accountBalanceTypesLoading;
/**
 * Returns the boolean AccountBalanceTypesLoading property.
 */
const getAccountBalanceTypesLoading = createSelector(getAccountBalanceTypeState, ɵ3);
const ɵ4 = (state) => state.accountBalanceTypesLoaded;
/**
 * Returns the boolean AccountBalanceTypesLoaded property.
 */
const getAccountBalanceTypesLoaded = createSelector(getAccountBalanceTypeState, ɵ4);
const ɵ5 = (state) => state.accountBalanceTypesLoadingFailed;
/**
 * Returns the boolean AccountBalanceTypeLoadingFailed property.
 */
const getAccountBalanceTypesLoadingFailed = createSelector(getAccountBalanceTypeState, ɵ5);

class BmyecNumberHelper {
    /**
     * Rounds a number to the given number of decimal places.
     * @param num The number to round.
     * @param decimalPlaces The decimal places to round to.
     * @returns The rounded number to the decimal places.
     */
    static roundNumber(num, decimalPlaces) {
        const roundedString = num.toFixed(decimalPlaces);
        return Number(roundedString);
    }
}

const PERCENTAGE_FORMAT_NUMBER = '1.6-6';
const AMOUNT_FORMAT_NUMBER = '1.2-2';
const YEAR_END_CLOSE_DEFAULT_SETTINGS = {
    enableCarryForwardTickmarks: false,
    enableCarryForwardWorkpaperReferences: false,
    enableZeroOutAccountBalances: false,
    fiscalYearId: undefined,
    netIncomeDistributions: [],
};

var bmyecConstants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    PERCENTAGE_FORMAT_NUMBER: PERCENTAGE_FORMAT_NUMBER,
    AMOUNT_FORMAT_NUMBER: AMOUNT_FORMAT_NUMBER,
    YEAR_END_CLOSE_DEFAULT_SETTINGS: YEAR_END_CLOSE_DEFAULT_SETTINGS
});

class BmyecYearEndCloseMainComponent {
    /**
     * @description
     *
     * Creates an instance of bmyec main component.
     *
     * @param modalService the modal service.
     * @param store the year end close store.
     */
    constructor(modalService, store) {
        this.modalService = modalService;
        this.store = store;
        this.modalClose = new EventEmitter();
        this.modalCancel = new EventEmitter();
        this.equityAccounts = [];
        this.subscription$ = new Subject();
    }
    /**
     * @description
     *
     * Opens the modal component.
     */
    openModal() {
        const modalInstance = this.modalService.open(BmyecYearEndCloseModalComponent, {
            windowClass: 'bmyec-workspace-modal',
            container: '#bentoNGModalContainer',
            backdrop: 'static',
            keyboard: false
        });
        modalInstance.result.then(() => {
            combineLatest([
                this.store.pipe(select(getYearEndCloseSetting)),
                this.store.pipe(select(getNetIncomeDistributions))
            ])
                .pipe(map(([yearEndCloseSetting, netIncomeDistributionData]) => ({
                yearEndCloseSetting,
                netIncomeDistributionData
            })), first((state) => state.yearEndCloseSetting !== undefined && state.netIncomeDistributionData !== undefined))
                .toPromise()
                .then((state) => {
                const yearEndCloseSetting = Object.assign({}, state.yearEndCloseSetting);
                // Verify if zero out account balance toggle is enabled
                if (yearEndCloseSetting.enableZeroOutAccountBalances) {
                    // If enableZeroOutAccountBalances is true then we need to make sure Net Income Distributions are sent to the backend
                    // as an empty array, the backend ignores this flag if it finds any distribution on the list.
                    yearEndCloseSetting.netIncomeDistributions = [];
                }
                else {
                    // The filtering is required to prevent any backend issue
                    // because the net income distributions grid allows to store empty rows
                    const netIncomeDistributions = state.netIncomeDistributionData.filter(distribution => distribution.accountId);
                    yearEndCloseSetting.netIncomeDistributions = netIncomeDistributions
                        .map((distribution) => (Object.assign(Object.assign({}, distribution), { distributionAmount: BmyecNumberHelper.roundNumber(distribution.distributionAmount, 2) })));
                }
                this.modalClose.emit(yearEndCloseSetting);
            });
        }, () => {
            this.modalCancel.emit();
        });
    }
    /**
     * Convert NetIncomeDistributions to NetIncomeDistributionsExtended.
     *
     * @param netIncomeDistributions The net income distriutions array.
     */
    convertNetIncomeDistributionsToExtended(netIncomeDistributions) {
        return netIncomeDistributions.map((distribution) => {
            let distributionExtended;
            distributionExtended = Object.assign(Object.assign({}, distribution), { 
                // We need to round the amount to 2 decimal places because that's what we do when saving, here in loading the values
                // is required because when reclosing a year a mismatch is being regurned since all decimals places were considered.
                distributionAmount: BmyecNumberHelper.roundNumber(distribution.distributionAmount, 2), account: this.getEquityAccountById(distribution.accountId) });
            return distributionExtended;
        });
    }
    /**
     * @description
     *
     * gets the equity account by id, otherwise returns empty account.
     *
     * @param id the account id.
     */
    getEquityAccountById(id) {
        const equityAccount = this.equityAccounts.find((acc) => acc.id === id);
        return equityAccount ? equityAccount : { id: '', ownerId: '', displayString: '' };
    }
    /**
     * @description
     *
     * Runs when the component gets initialized.
     */
    ngOnInit() {
        this.store.dispatch(new LoadFiscalYears({ ownerId: this.ownerId }));
        // We send the retried option as false to indicate the LoadYearEndCloseSettings dispatch
        // this is the first call made and will try to load the settings for the current fiscalYear.
        this.store.dispatch(new LoadYearEndCloseSettings({
            ownerId: this.ownerId,
            fiscalYearId: this.fiscalYearId,
            retried: false
        }));
        combineLatest([
            this.store.pipe(select(getFiscalYearState), first(fiscalYearState => fiscalYearState.fiscalYearsLoaded)),
            this.store.pipe(select(getYearEndCloseSettingState), 
            // This flow will enter only when the call to load the settings for the current fiscalYear failed
            // meaning there are no settings saved and will try to load the setting for the previous
            // fiscalYear.
            first(yecSettings => yecSettings.yearEndCloseSettingFailed))
        ]).pipe(takeUntil(this.subscription$)).subscribe(() => {
            this.store.pipe(select(getPreviousFiscalYear, { fiscalYearId: this.fiscalYearId }))
                .pipe(takeUntil(this.subscription$)).subscribe(fiscalYear => {
                if (fiscalYear && fiscalYear.id) {
                    // By passing the retried flag as true on this call we tell the store that the settings loaded are
                    // for the previous fiscalYear.
                    this.store.dispatch(new LoadYearEndCloseSettings({
                        ownerId: this.ownerId,
                        fiscalYearId: fiscalYear.id,
                        retried: true
                    }));
                }
                else {
                    // In case no settings were found neither for the current fiscalYear or the previous fiscalYear
                    // we will load the default settings.
                    const defaultSettings = Object.assign(Object.assign({}, YEAR_END_CLOSE_DEFAULT_SETTINGS), { fiscalYearId: this.fiscalYearId });
                    this.store.dispatch(new LoadDefaultYearEndCloseSettings({ defaultSettings }));
                }
            });
        });
        this.store.dispatch(new SetYearEndCloseInputs({
            fiscalYearNumber: this.fiscalYear,
            contactDisplayName: this.contactDisplayName,
            ownerId: this.ownerId
        }));
        this.store.dispatch(new LoadEquityAccounts({ ownerId: this.ownerId }));
        this.store.dispatch(new LoadAccountBalanceTypes({ ownerId: this.ownerId }));
        this.store.dispatch(new LoadAccountGroups({ ownerId: this.ownerId }));
        // Synchronized AdjustedBalanceType and FiscalYearState data in order to get
        // adjustedType id only when fiscal year state has been loaded
        combineLatest([
            this.store.pipe(select(getAdjustedBalanceType)),
            this.store.pipe(select(getFiscalYearLastPeriod, { fiscalYearId: this.fiscalYearId }))
        ]).pipe(map(([adjustedType, lastPeriod]) => ({
            adjustedType, lastPeriod
        })), first((state) => state.adjustedType !== undefined && state.lastPeriod !== undefined)).toPromise()
            .then(state => {
            this.store.dispatch(new LoadNetIncomeTotals({
                ownerId: this.ownerId,
                adjustedBalanceTypeId: state.adjustedType.id,
                periodSequenceNumber: state.lastPeriod.sequenceNumber.toString()
            }));
        });
        combineLatest([
            this.store.pipe(select(getEquityAccountState)),
            this.store.pipe(select(getYearEndCloseSettingState)),
            this.store.pipe(select(getNetIncomeDistributionDataState))
        ]).pipe(map(([equityAccountState, yearEndCloseSettingState, netIncomeDistributionDataState]) => ({
            equityAccountState, yearEndCloseSettingState, netIncomeDistributionDataState
        })), first((combinedState) => {
            return combinedState.equityAccountState.equityAccountsLoaded &&
                combinedState.yearEndCloseSettingState.yearEndCloseSettingLoaded &&
                combinedState.netIncomeDistributionDataState.netIncomeTotalLoaded;
        })).toPromise()
            .then(combinedState => {
            this.equityAccounts = combinedState.equityAccountState.equityAccounts;
            const yecSettings = combinedState.yearEndCloseSettingState.yearEndCloseSetting;
            const netIncomeTotal = combinedState.netIncomeDistributionDataState.distributionSummary.netIncomeTotal;
            const distributions = [];
            if (yecSettings.fiscalYearId !== this.fiscalYearId) {
                this.store.dispatch(new UpdateYearEndCloseSettings({
                    updatedSettings: Object.assign(Object.assign({}, yecSettings), { id: null, fiscalYearId: this.fiscalYearId })
                }));
            }
            yecSettings.netIncomeDistributions.forEach((distribution) => {
                distributions.push(Object.assign(Object.assign({}, distribution), { distributionAmount: (distribution.distributionPercentage * netIncomeTotal) / 100, id: yecSettings.fiscalYearId === this.fiscalYearId ? distribution.id : null }));
            });
            this.store.dispatch(new SetNetIncomeDistributions({
                distributions: this.convertNetIncomeDistributionsToExtended(distributions)
            }));
            this.openModal();
        });
    }
    ngOnDestroy() {
        this.store.dispatch(new ResetNetIncomeDistributions());
        if (this.subscription$) {
            this.subscription$.next();
            this.subscription$.complete();
        }
    }
}
BmyecYearEndCloseMainComponent.ɵfac = function BmyecYearEndCloseMainComponent_Factory(t) { return new (t || BmyecYearEndCloseMainComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Store)); };
BmyecYearEndCloseMainComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BmyecYearEndCloseMainComponent, selectors: [["bmyec-year-end-close-main"]], inputs: { ownerId: "ownerId", fiscalYearId: "fiscalYearId", fiscalYear: "fiscalYear", contactDisplayName: "contactDisplayName" }, outputs: { modalClose: "modalClose", modalCancel: "modalCancel" }, decls: 1, vars: 0, consts: [[1, "bmyec-ng-bento"]], template: function BmyecYearEndCloseMainComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } }, styles: [".bmyec-workspace-modal .modal-dialog .modal-content{border:0!important;border-radius:0!important;height:100vh!important;margin:0!important;overflow-x:hidden!important;overflow-y:auto!important;padding:0!important;width:100%!important}.bmyec-workspace-modal .modal-dialog{margin:0}.bmyec-workspace-modal .bmyec-workspace-modal-header{background-color:#212121;border:0;box-shadow:0 1px 3px rgba(0,0,0,.1),0 1px 7px rgba(0,0,0,.15);clear:both;display:block;height:60px;line-height:53px;position:absolute;top:0;white-space:nowrap;width:100%;z-index:101}.bmyec-workspace-modal .bmyec-workspace-modal-header h1,.bmyec-workspace-modal .bmyec-workspace-modal-header h2,.bmyec-workspace-modal .bmyec-workspace-modal-header h3{color:#fff;line-height:60px;margin:0}.bmyec-workspace-padding{padding:0 10px!important}.bmyec-workspace-modal-header button{margin-left:10px;margin-right:5px}.bmyec-workspace-modal .modal-title{padding-left:10px!important}.bmyec-workspace-modal .modal-workspace-body{bottom:0;display:block;margin-left:10px;overflow:hidden;padding:20px;position:absolute;top:60px;width:100%}.bmyec-workspace-modal .modal-dialog{padding:0!important}.bmyec-form-header{margin-bottom:10px}.bmyec-form-label{padding-right:5px}.bmyec-ng-bento .fade{opacity:unset}.bmyec-bento-toggle bento-toggle{margin-left:20px}.bmyec-bento-toggle .bmyec-clear-balances-toggle{height:22px;width:36px}.bmyec-clear-balances-toggle .bento-toggle-nob{height:22px;width:22px}.bmyec-bento-toggle bento-toggle.on .bento-toggle-nob{left:13px!important}.ng-bento ngb-modal-window.bmyec-workspace-modal+ngb-modal-backdrop.modal-backdrop{z-index:1150!important}"], encapsulation: 2 });
BmyecYearEndCloseMainComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: Store }
];
BmyecYearEndCloseMainComponent.propDecorators = {
    ownerId: [{ type: Input }],
    fiscalYearId: [{ type: Input }],
    fiscalYear: [{ type: Input }],
    contactDisplayName: [{ type: Input }],
    modalClose: [{ type: Output }],
    modalCancel: [{ type: Output }]
};

class BmyecToolbarService {
    /**
     * @description
     *
     * Creates an instance of bmyec toolbar service.
     *
     * @param translateService the translation service.
     */
    constructor(translateService) {
        this.translateService = translateService;
    }
    /**
     * Gets net income grid delete button
     *
     * @param deleteAction the action to execute when delete button is added.
     *
     * @returns the net income grid delete button.
     */
    getDeleteButton(deleteAction) {
        return this.createButton('bmyec_delete', 'bento-icon-remove', deleteAction, true);
    }
    /**
     * Gets net income grid add buttons
     *
     * @param addAction the action to execute when add button is added.
     *
     * @returns the net income grid add button.
     */
    getAddButton(addAction) {
        return this.createButton('bmyec_add', 'bento-icon-add', addAction, false);
    }
    /**
     * Gets net income grid add buttons
     *
     * @param label the label translation key of the button.
     *
     * @param icon the icon class of the button.
     *
     * @param action the action to execute.
     *
     * @returns the toolbar button.
     */
    createButton(label, icon, action, disabled) {
        return { label: this.translateService.instant(label), icon, action, disabled };
    }
}
BmyecToolbarService.ɵfac = function BmyecToolbarService_Factory(t) { return new (t || BmyecToolbarService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService)); };
BmyecToolbarService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BmyecToolbarService_Factory() { return new BmyecToolbarService(i0.ɵɵinject(i1.TranslateService)); }, token: BmyecToolbarService, providedIn: "root" });
BmyecToolbarService.ctorParameters = () => [
    { type: TranslateService }
];

const ɵ0$1 = (state) => state.categoryNodeOptionsState;
/**
 * Returns the CategoryNodeOptionsState.
 */
const getCategoryNodeOptionsState = createSelector(getYearEndCloseState, ɵ0$1);
const ɵ1$1 = (state) => {
    const categoryNodeOptions = new Map();
    for (const key in state.entities) {
        if (state.entities[key]) {
            categoryNodeOptions[key] = state.entities[key].categoryNodeOptions;
        }
    }
    return categoryNodeOptions;
};
/**
 * Returns the categoryNodeOptions array.
 */
const getCategoryNodeOptions = createSelector(getCategoryNodeOptionsState, ɵ1$1);

const ɵ0 = (state) => state.accountGroupsState;
/**
 * Returns the AccountingState.
 */
const getAccountGroupsState = createSelector(getYearEndCloseState, ɵ0);
const ɵ1 = (state) => state.accountGroupsState.accountGroups;
/**
 * Returns the account groups.
 */
const getAccountGroups = createSelector(getYearEndCloseState, ɵ1);

/**
 * @description
 *
 * Enum used to specify the index of each grid column.
 */
var GridColumnIndex;
(function (GridColumnIndex) {
    GridColumnIndex[GridColumnIndex["CHECKBOX"] = 0] = "CHECKBOX";
    GridColumnIndex[GridColumnIndex["EQUITY_ACCOUNTS"] = 1] = "EQUITY_ACCOUNTS";
    GridColumnIndex[GridColumnIndex["DISTRIBUTION_PERCENTAGE"] = 2] = "DISTRIBUTION_PERCENTAGE";
    GridColumnIndex[GridColumnIndex["DISTRIBUTION_AMOUNT"] = 3] = "DISTRIBUTION_AMOUNT";
})(GridColumnIndex || (GridColumnIndex = {}));

var HeaderCheckboxStatus;
(function (HeaderCheckboxStatus) {
    HeaderCheckboxStatus[HeaderCheckboxStatus["CHECKBOX_SELECTED"] = 1] = "CHECKBOX_SELECTED";
    HeaderCheckboxStatus[HeaderCheckboxStatus["CHECKBOX_UNSELECTED"] = 2] = "CHECKBOX_UNSELECTED";
    HeaderCheckboxStatus[HeaderCheckboxStatus["CHECKBOX_INDETERMINATE"] = 3] = "CHECKBOX_INDETERMINATE";
})(HeaderCheckboxStatus || (HeaderCheckboxStatus = {}));
class BmyecNetIncomeDistributionGridComponent {
    /**
     * @description
     *
     * Creates an instance of bmyec net income distribution grid component.
     *
     * @param store the store for the year end close state.
     * @param bmyecToolbarService the toolbar service.
     * @param bmyecGridValidatorService The grid validator service.
     * @param bmyecEventQueueService The event queue service.
     * @param translateService service to translate text
     */
    constructor(store, bmyecToolbarService, bmyecGridValidatorService, bmyecEventQueueService, translateService) {
        this.store = store;
        this.bmyecToolbarService = bmyecToolbarService;
        this.bmyecGridValidatorService = bmyecGridValidatorService;
        this.bmyecEventQueueService = bmyecEventQueueService;
        this.translateService = translateService;
        this.DEFAULT_GRID_ROW_NUMBER = 4;
        this.constants = bmyecConstants;
        this.equityAccounts = [];
        this.hasEquityAccounts = true;
        this.headerCheckboxMode = HeaderCheckboxStatus.CHECKBOX_UNSELECTED;
        this.showErrors = false;
        this.observableCurrentIndex = -1;
        this.subscription$ = new Subscription();
        this.modalOpened = false;
        this.isCloseModal = true;
        this.currentRow = -1;
        // Used to disable the grid to be edited when there is nothing to distribute
        this.isReadOnly = false;
        /**
         * @description
         *
         * Equity account combobox options of bmyec net income distribution grid component that includes:
         * - labelFormatter that formats the account for display.
         * - searchCompare that compares on the display string.
         * - searchable: flag to mark the combobox as searchable.
         */
        this.equityAccountComboboxOptions = {
            labelFormatter: (row) => {
                return row.displayString;
            },
            searchCompare: (row, search) => {
                const searchLowerCase = search.toLocaleLowerCase();
                const name = row.displayString.toLowerCase();
                return name.indexOf(searchLowerCase) > -1;
            },
            searchable: true,
            footerItems: [
                {
                    label: this.translateService.instant('bmyec_add_equity_account_dropdown'),
                    icon: 'bento-icon-add',
                    defaultItemText: this.translateService.instant('bmyec_add_equity_account_dropdown'),
                    clearInputOnAction: true,
                    collapseOnAction: true,
                    action: () => {
                        this.openAddEquityAccountModal();
                    }
                }
            ]
        };
        /**
         * @description
         * Sets the styles of the grid.
         *
         * @param grid constains the entire grid.
         * @param row row number of the current cell.
         * @param column column number of the current cell.
         * @param cell contains the current cell object.
         */
        this.itemFormatter = (grid, row, column, cell) => {
            if (column === GridColumnIndex.DISTRIBUTION_PERCENTAGE || column === GridColumnIndex.DISTRIBUTION_AMOUNT) {
                cell.classList.add('bmyec-text-alignment-right');
                if ((grid.cellType !== wjcGrid.CellType.ColumnHeader)) {
                    cell.classList.add('bmyec-input');
                }
            }
            else if ((grid.cellType === wjcGrid.CellType.ColumnHeader || grid.cellType === wjcGrid.CellType.Cell)
                && (column === GridColumnIndex.CHECKBOX)) {
                cell.classList.add('bmyec-checkbox');
            }
            if (grid.cellType === wjcGrid.CellType.ColumnHeader) {
                cell.classList.add('bmyec-grid-header-capitalization');
            }
        };
        this.allowSorting = wjcGrid.AllowSorting.None;
    }
    /**
     * @description
     *
     * get empty Distribution.
     */
    getEmptyDistribution() {
        return {
            accountId: '',
            distributionPercentage: null,
            distributionAmount: null,
            yearEndCloseSettingId: '',
            account: { id: '', ownerId: '', displayString: '' }
        };
    }
    /**
     * @description
     *
     * Return true if all net income distributions are empty or false if at least one has values.
     *
     */
    areAllDistributionsEmpty() {
        const emptyDistribution = this.getEmptyDistribution();
        const distributionsNotEmpty = this.netIncomeDistributions.items.filter((distribution) => {
            return distribution.accountId !== emptyDistribution.accountId ||
                distribution.distributionPercentage !== emptyDistribution.distributionPercentage ||
                distribution.distributionAmount !== emptyDistribution.distributionAmount;
        });
        return distributionsNotEmpty.length === 0;
    }
    /**
     * @description
     *
     * Adds blank item to grid.
     *
     */
    addBlankRowToGrid() {
        this.addItemToGrid(this.getEmptyDistribution());
        this.updateSelectedEquityAccounts();
        if (this.netIncomeDistGrid) {
            this.netIncomeDistGrid.refresh();
        }
    }
    /**
     * @description
     *
     * get default distribution.
     *
     */
    getDefaultDistribution() {
        return {
            accountId: '',
            distributionPercentage: 100,
            distributionAmount: this.adjustedNetIncomeTotal ? this.adjustedNetIncomeTotal : 0,
            yearEndCloseSettingId: '',
            account: {
                id: '',
                ownerId: '',
                displayString: ''
            }
        };
    }
    /**
     * @description
     *
     * Adds default row to grid.
     *
     */
    addDefaultRowToGrid() {
        this.addItemToGrid(this.getDefaultDistribution());
    }
    /**
     * @description
     *
     * Update Default distribution
     */
    updateDefaultDistribution() {
        if (this.netIncomeDistributions.items.length === 0) {
            this.addDefaultRowToGrid();
        }
        else if (this.areAllDistributionsEmpty()) {
            this.store.dispatch(new UpdateNetIncomeDistribution({
                index: 0,
                distribution: this.getDefaultDistribution()
            }));
        }
    }
    /**
     * @description
     *
     * Removes selected items from grid.
     *
     */
    removeSelectedItemsFromGrid() {
        const indexes = this.netIncomeDistributions.items.reduce((idx, item, index) => {
            if (item.selected) {
                idx.push(index);
            }
            return idx;
        }, []);
        this.store.dispatch(new RemoveNetIncomeDistribution({
            indexes
        }));
        this.updateDefaultDistribution();
        this.updateSelectedEquityAccounts();
    }
    /**
     * @description
     *
     * Returns if headerCheckboxMode is selected.
     *
     * @returns if headerCheckboxMode is selected.
     */
    allSelected() {
        return this.headerCheckboxMode === HeaderCheckboxStatus.CHECKBOX_SELECTED;
    }
    /**
     * @description
     *
     * Determines whether header is indeterminate
     *
     * @returns true if header is indeterminate.
     */
    isHeaderIndeterminate() {
        return this.headerCheckboxMode === HeaderCheckboxStatus.CHECKBOX_INDETERMINATE;
    }
    /**
     * @description
     *
     * Determines whether header checkbox change effects on the grid rows.
     */
    onHeaderCheckboxChange() {
        if (this.headerCheckboxMode !== HeaderCheckboxStatus.CHECKBOX_SELECTED) {
            this.setHeaderCheckboxMode(HeaderCheckboxStatus.CHECKBOX_SELECTED);
        }
        else {
            this.setHeaderCheckboxMode(HeaderCheckboxStatus.CHECKBOX_UNSELECTED);
        }
    }
    /**
     * @description
     *
     * Sets the contents of the header checkbox based on which rows are selected.
     */
    rowSelectionChanged() {
        // Only when collection has elements and all of them are selected then allSelectedRows is true.
        const allSelectedRows = this.netIncomeDistributions.items.every((row) => row.selected)
            && this.netIncomeDistributions.sourceCollection.length > 0;
        // Check if any selecte row is selected in the grid, to validate later with the allSelectedRows previously defined.
        const anySelectedRow = this.netIncomeDistributions.sourceCollection.some((row) => row.selected);
        // All rows selected
        if (allSelectedRows) {
            this.headerCheckboxMode = HeaderCheckboxStatus.CHECKBOX_SELECTED;
            this.enableDeleteRowButton();
            // At least one row selected
        }
        else if (anySelectedRow) {
            this.headerCheckboxMode = HeaderCheckboxStatus.CHECKBOX_INDETERMINATE;
            this.enableDeleteRowButton();
        }
        else {
            // No rows selected
            this.headerCheckboxMode = HeaderCheckboxStatus.CHECKBOX_UNSELECTED;
            this.disableDeleteRowButton();
        }
    }
    /**
     * @description
     *
     * Sets the disable property of the delete row grid button.
     */
    setDeleteButtonDisabled(disabled) {
        // If there is only one row in the grid, the delete button will always be disabled
        disabled = this.netIncomeDistributions.sourceCollection.length === 1 ? true : disabled;
        this.deleteButton.disabled = disabled;
        this.toolbar.refresh();
    }
    /**
     * @description
     *
     * Sets the disable property of the add row grid button.
     */
    setAddButtonDisabled(disabled) {
        this.addButton.disabled = disabled;
        this.toolbar.refresh();
    }
    /**
     * @description
     *
     * Disable the delete row grid button.
     */
    disableDeleteRowButton() {
        this.setDeleteButtonDisabled(true);
    }
    /**
     * @description
     *
     * Enable the delete row grid button.
     */
    enableDeleteRowButton() {
        this.setDeleteButtonDisabled(false);
    }
    /**
     * @description
     *
     * Sets the header checkbox mode status.
     */
    setHeaderCheckboxMode(headerCheckboxStatus) {
        this.headerCheckboxMode = headerCheckboxStatus;
        const isSelected = this.headerCheckboxMode === HeaderCheckboxStatus.CHECKBOX_SELECTED;
        this.store.dispatch(new SetNetIncomeDistributionsSelection({
            selection: isSelected
        }));
        isSelected ? this.enableDeleteRowButton() : this.disableDeleteRowButton();
    }
    /**
     * @description
     *
     * Sets the toolbar buttons.
     */
    setToolbarButtons() {
        this.addButton = this.bmyecToolbarService.getAddButton(this.addBlankRowToGrid.bind(this));
        this.deleteButton = this.bmyecToolbarService.getDeleteButton(this.removeSelectedItemsFromGrid.bind(this));
        this.toolbarButtons = [this.addButton, this.deleteButton];
    }
    /**
     * @description
     *
     * Runs the code when the component is initialized.
     */
    ngOnInit() {
        this.setToolbarButtons();
        this.subscription$.add(this.store.pipe(select(getEquityAccounts))
            .subscribe((accounts) => {
            this.equityAccounts = accounts;
            this.hasEquityAccounts = accounts.length !== 0;
            this.setAddButtonDisabled(!this.hasEquityAccounts);
        }));
        this.store.pipe(select(getNetIncomeDistributionDataState), first(state => state.netIncomeTotalLoaded))
            .toPromise()
            .then((netIncomeState) => {
            // The adjustedNetIncomeTotal variable will be assigned until the flag
            // netIncomeTotalLoaded is true to make sure the displayed calculations
            // in the grid are correct, this value defaults to zero as per store design.
            this.adjustedNetIncomeTotal = netIncomeState.distributionSummary.netIncomeTotal;
            if (netIncomeState.distributionSummary.netIncomeTotal === 0) {
                this.hasEquityAccounts = true;
                this.isReadOnly = true;
                if (netIncomeState.netIncomeDistributions.length === 0) {
                    this.addDefaultRowToGrid();
                }
                this.setAddButtonDisabled(true);
            }
            else {
                if (netIncomeState.netIncomeDistributions.length === 0) {
                    this.initializeDefaultGridRows();
                }
                this.updateSelectedEquityAccounts();
            }
        });
        this.subscription$.add(this.store.pipe(select(getNetIncomeDistributions))
            .subscribe((distributions) => {
            this.bmyecGridValidatorService.setGridCollectionData(distributions);
            this.netIncomeDistributions = new wjcCore.CollectionView(distributions.map(distribution => (Object.assign({}, distribution))), {
                getError: (item, property) => {
                    switch (property) {
                        case 'distributionPercentage':
                            return this.bmyecGridValidatorService.validateDistributionPercentage(item);
                        case 'distributionAmount':
                            return this.bmyecGridValidatorService.validateDistributionAmount(item);
                        case 'account':
                            return this.bmyecGridValidatorService.validateEquityAccount(item);
                    }
                    return null;
                }
            });
        }));
        this.subscription$.add(this.store.pipe(select(getNetIncomeDistributionSummary))
            .subscribe((distributionSummary) => {
            this.bmyecGridValidatorService.setDistributionSummaryData(distributionSummary);
        }));
        this.store
            .pipe(select(getYearEndCloseInputsState), first(state => state !== undefined))
            .toPromise()
            .then(yearEndCloseInputs => {
            this.ownerId = yearEndCloseInputs.ownerId;
        });
        // The isDirtyObservable is returned once the grid has been validated
        // (YEC close button has ben clicked), the showErrors flag controls wether
        // the distribution grid must show errors or not.
        this.bmyecGridValidatorService.getIsDirtyGridObservable()
            .pipe(first(isDirty => isDirty === true))
            .toPromise().then(isDirty => this.showErrors = isDirty);
    }
    /**
     * @description
     * Handles the event when the items source changed on the grid.
     */
    itemsSourceChanged() {
        if (this.selection) {
            this.netIncomeDistGrid.selection = this.selection;
        }
    }
    /**
     * @description
     * Handles the event when the items source is going to change on the grid.
     */
    itemsSourceChanging() {
        this.selection = this.netIncomeDistGrid ? this.netIncomeDistGrid.selection : undefined;
    }
    /**
     * Initializes default grid rows when Net Income Amount is zero.
     */
    initializeDefaultGridRows() {
        for (let i = 1; i < this.DEFAULT_GRID_ROW_NUMBER; i++) {
            this.addBlankRowToGrid();
        }
        this.addDefaultRowToGrid();
    }
    /**
     * @description
     *
     * Runs the code when the component is destroyed.
     */
    ngOnDestroy() {
        this.bmyecEventQueueService.clearFocusCloseButton();
        this.bmyecGridValidatorService.setGridAsPristine();
        if (this.subscription$) {
            this.subscription$.unsubscribe();
        }
    }
    /**
     * @description
     *
     * account bento-combobox change event handler.
     *
     * @param acct the account.
     * @param rowIndex the index of the array.
     * @param distribution the distribution.
     */
    onAccountChange(acct, rowIndex, distribution) {
        const account = acct ? Object.assign({}, acct) : { id: '', ownerId: '', displayString: '' };
        this.currentRow = rowIndex;
        this.store.dispatch(new UpdateNetIncomeDistribution({
            index: rowIndex,
            distribution: Object.assign(Object.assign({}, distribution), { account, accountId: account.id })
        }));
        this.updateDefaultDistribution();
        this.updateSelectedEquityAccounts();
    }
    /**
     * @description
     *
     * Event handler for grid initialization.
     */
    gridInitialized() {
        this.setupEdit();
    }
    /**
     * @description
     *
     * Setup the edit for the grid and the keyup event handler.
     */
    setupEdit() {
        const host = this.netIncomeDistGrid.hostElement;
        host.addEventListener('keyup', this.keyUpEvent.bind(this));
        host.addEventListener('wheel', this.mouseWheelEvent.bind(this), true);
        const tooltip = new wjcCore.Tooltip();
        tooltip.cssClass = 'bmyec-cell-error-tooltip';
        this.netIncomeDistGrid.errorTip = tooltip;
        this.netIncomeDistGrid.beginningEdit.addHandler((_handler, event) => {
            this.rowIndexSelected = event.row;
        });
    }
    /**
     * @description
     *
     * Will prevent to increase or decrease the value when wheel scroll event is
     * performed over the grid inputs of number type.
     *
     * @param event Event of type WheelEvent detected on mouse wheel.
     */
    mouseWheelEvent(event) {
        event.stopPropagation();
    }
    /**
     * Grids selection changed event.
     * Sets edit mode to the selected cell.
     *
     * @param cellPosition The cell position.
     */
    gridSelectionChanged(cellPosition) {
        const grid = this.netIncomeDistGrid;
        if (cellPosition.row >= 0 && cellPosition.col >= 0) {
            const selectedRange = grid.selection;
            selectedRange.row = cellPosition.row;
            selectedRange.col = cellPosition.col;
            this.selectRange(grid, selectedRange);
        }
    }
    /**
     * @description
     *
     * Selects range in grid and sets editable.
     *
     * @param grid The grid.
     * @param range The range of selection.
     */
    selectRange(grid, range) {
        grid.select(range, true);
        grid.startEditing(false, grid.selection.row, grid.selection.col);
    }
    /**
     * @description
     *
     * Set row selection.
     *
     * @param index Row grid number
     * @param item The distribution item.
     */
    setRowSelection(index, item) {
        this.store.dispatch(new UpdateNetIncomeDistribution({ index, distribution: item }));
    }
    /**
     * Key up event to handle tab and enter keys.
     *
     * @param ev the KeyboardEvent.
     */
    keyUpEvent(ev) {
        const grid = this.netIncomeDistGrid;
        const tabKey = 'Tab';
        const enterKey = 'Enter';
        const validKeys = [tabKey, enterKey];
        const selectedRange = grid.selection;
        const validColumns = [
            GridColumnIndex.EQUITY_ACCOUNTS,
            GridColumnIndex.DISTRIBUTION_PERCENTAGE,
            GridColumnIndex.DISTRIBUTION_AMOUNT
        ];
        if (validKeys.includes(ev.key) && (validColumns.includes(selectedRange.col))) {
            selectedRange.row = this.currentRow !== -1 ? this.currentRow : selectedRange.row;
            switch (ev.key) {
                case tabKey:
                    if (selectedRange.col < this.netIncomeDistGrid.columns.length - 1) {
                        selectedRange.col++;
                    }
                    else {
                        if (selectedRange.row === this.netIncomeDistGrid.rows.length - 1) {
                            this.bmyecEventQueueService.setFocusCloseButton(true);
                            break;
                        }
                        else {
                            selectedRange.col = GridColumnIndex.EQUITY_ACCOUNTS;
                            selectedRange.row = selectedRange.row + 1;
                        }
                    }
                    this.selectRange(grid, selectedRange);
                    break;
                default:
                    // Defaults to ENTER key.
                    if (selectedRange.row < this.netIncomeDistGrid.rows.length) {
                        if (selectedRange.col === GridColumnIndex.EQUITY_ACCOUNTS || this.currentRow !== -1) {
                            selectedRange.row++;
                        }
                    }
                    this.selectRange(grid, selectedRange);
            }
            this.currentRow = -1;
        }
    }
    /**
     * @description
     *
     * Extract the selected equity accounts per grid index and sets them on the store.
     * This method ignores the rows that have no selected equity account.
     */
    updateSelectedEquityAccounts() {
        const selectedAccounts = this.netIncomeDistributions.sourceCollection.filter((row) => row.account && row.account.id)
            .map((row) => row.account.id);
        this.store.dispatch(new SetSelectedEquityAccounts({ data: selectedAccounts }));
        this.observableCurrentIndex = -1;
    }
    /**
     * @description
     *
     * Gets equity account observable with the accounts to display.
     * Since this observable is being consumed multiple times on the UI event, we keep track of the current index
     * so we only call the store select when actual change of index occurs and prevent the screen to hung.
     *
     * @param index the grid index.
     * @returns the accounts observable.
     */
    getEquityAccountObservable(index) {
        if (this.observableCurrentIndex !== index) {
            this.equityAccounts$ = this.store.pipe(select(getAvailableEquityAccounts));
            this.observableCurrentIndex = index;
        }
        return this.equityAccounts$;
    }
    /**
     * @description
     * Calculated distribution amount by percentage.
     *
     * @param percentage Percentage to be calculated
     * @returns Percentage calculated with NetIncomeTotal.
     */
    calculatedDistributionAmountByPercentage(percentage) {
        const distributionAmount = (this.adjustedNetIncomeTotal * percentage) / 100;
        return BmyecNumberHelper.roundNumber(distributionAmount, 2);
    }
    /**
     * @description
     * Change percentage.
     *
     * @param distributionPercentage Updated distribution percentage amount value.
     * @param distribution YearEndNetIncomeDistributionExtended changed.
     * @param rowIndex row index.
     */
    changePercentage(distributionPercentage, distribution, rowIndex) {
        this.currentRow = rowIndex;
        const distributionAmount = distributionPercentage === null
            ? null
            : this.calculatedDistributionAmountByPercentage(distributionPercentage);
        this.store.dispatch(new UpdateNetIncomeDistribution({
            index: rowIndex,
            distribution: Object.assign(Object.assign({}, distribution), { distributionPercentage,
                distributionAmount })
        }));
        this.updateDefaultDistribution();
    }
    /**
     * Calculated distribution amount by percentage
     * @param amount Percentage to be calculated
     * @returns Percentage calculated with NetIncomeTotal.
     */
    calculatedDistributionPercentageByAmount(amount) {
        const distributionPercentage = this.adjustedNetIncomeTotal === 0 ? 100.00000 : ((amount * 100) / this.adjustedNetIncomeTotal);
        return distributionPercentage;
    }
    /**
     * @description
     * Change amount.
     *
     * @param distributionAmount Updated distribution amount value.
     * @param distribution YearEndNetIncomeDistributionExtended changed.
     * @param index The index of the distribution.
     */
    changeAmount(distributionAmount, distribution, index) {
        this.currentRow = index;
        const distributionPercentage = distributionAmount === null
            ? null
            : this.calculatedDistributionPercentageByAmount(distributionAmount);
        this.store.dispatch(new UpdateNetIncomeDistribution({
            index,
            distribution: Object.assign(Object.assign({}, distribution), { distributionAmount,
                distributionPercentage })
        }));
        this.updateDefaultDistribution();
    }
    /**
     * @description
     * Adds item to grid and refresh the grid.
     *
     * @param yearEndNetIncomeDistribution The Year End Net Income Distribution
     * data to be added as row to the grid.
     */
    addItemToGrid(yearEndNetIncomeDistribution) {
        this.store.dispatch(new AddNetIncomeDistribution({
            distribution: Object.assign({}, yearEndNetIncomeDistribution)
        }));
    }
    /**
     * @description
     * Handles the refresh of the grid layout to resize to the correct width and height the grid rows.
     */
    refreshGridLayout() {
        if (this.netIncomeDistGrid && this.netIncomeDistributions.items.length > 0) {
            this.netIncomeDistGrid.autoSizeRows();
        }
        this.rowSelectionChanged();
    }
    /**
     * @description
     * Detects the click event over a cell to enter automatically to the edit mode.
     */
    onCellClicked(event) {
        const clickEventInfo = this.netIncomeDistGrid.hitTest(event);
        if (clickEventInfo.col > 0) {
            this.currentRow = clickEventInfo.row;
            this.gridSelectionChanged(clickEventInfo);
        }
    }
    /**
     * @description
     * Detects whens a cell has ended being edited and based on the event column and row
     * updates in the store the data accordingly.
     *
     * @param event Contains the updated value of the cell, cell and row number properties
     * required to identify the value to be updated on the store.
     */
    cellEditEnded(event) {
        if (event.data === undefined) {
            return;
        }
        const cellValue = event.data;
        const rowNumber = event.row;
        const percentageColumnNumber = 2;
        const amountColumnNumber = 3;
        const currentDistribution = this.netIncomeDistGrid.rows[rowNumber].dataItem;
        switch (event.col) {
            case percentageColumnNumber:
                this.changePercentage(cellValue, currentDistribution, rowNumber);
                break;
            case amountColumnNumber:
                // To prevent confusion on user, only update percentage when there is an actual visual change on the amount.
                // Also, since when the cell has null value and gets updated, for some reason the distribution object gets updated
                // before this method gets executed so the check on the percentage null is required.
                if (currentDistribution.distributionPercentage === null ||
                    cellValue !== BmyecNumberHelper.roundNumber(currentDistribution.distributionAmount, 2)) {
                    this.changeAmount(cellValue, currentDistribution, rowNumber);
                }
                break;
        }
    }
    /**
     * @description
     * Loads all Equity Categories and open modal.
     *
     */
    openAddEquityAccountModal() {
        return __awaiter(this, void 0, void 0, function* () {
            this.initializeAddAccountSettings();
            this.addAccountSettings.groupingSchedules = yield this.store.pipe(select(getAccountGroups), first(accounts => accounts.length > 0))
                .toPromise();
            this.addAccountSettings.categoryNodeMappingOptions = yield this.store.pipe(select(getCategoryNodeOptions), first(state => state !== undefined))
                .toPromise();
            this.modalOpened = true;
            this.isCloseModal = false;
        });
    }
    /**
     * @description
     * Set modalOpened flag to false
     */
    setModalOpenedAsFalse() {
        this.modalOpened = false;
    }
    /**
     * @description
     * Set isCloseModal flag to true
     */
    setIsCloseModalAsTrue() {
        this.isCloseModal = true;
    }
    /**
     * @description
     * Create initial settings for add account modal
     *
     */
    initializeAddAccountSettings() {
        this.addAccountSettings = {
            isEquityAccountModal: true,
            categoryNodeMappingOptions: new Map(),
            defaultFirstGrouping: true
        };
    }
    /**
     * @description
     * Event triggered by modal after add an equity account.
     *
     * @param $event: array with all equity accounts added (always one)
     */
    addNewEquityAccount($event) {
        this.hasEquityAccounts = true;
        const equityAccount = Object.assign({}, $event[0].account);
        const index = this.rowIndexSelected === undefined ? 0 : this.rowIndexSelected;
        const distribution = this.netIncomeDistGrid ? this.netIncomeDistGrid.rows[index].dataItem : this.getDefaultDistribution();
        equityAccount.displayString = this.createDisplayString(equityAccount);
        this.store.dispatch(new AddEquityAccount({ equityAccount }));
        this.store.dispatch(new SetEquityAccountToNetIncomeDistribution({ equityAccount, index }));
        this.onAccountChange(equityAccount, index, distribution);
        if (this.isCloseModal) {
            this.modalOpened = false;
        }
    }
    /**
     * @description
     * Add displayString property to a new equity account.
     *
     * @param account: equity account to add property
     */
    createDisplayString(account) {
        if (account.accountNumber && account.description) {
            return `${account.accountNumber} | ${account.description}`;
        }
        if (account.accountNumber) {
            return account.accountNumber;
        }
        if (account.description) {
            return account.description;
        }
        return '';
    }
}
BmyecNetIncomeDistributionGridComponent.ɵfac = function BmyecNetIncomeDistributionGridComponent_Factory(t) { return new (t || BmyecNetIncomeDistributionGridComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Store), ɵngcc0.ɵɵdirectiveInject(BmyecToolbarService), ɵngcc0.ɵɵdirectiveInject(BmyecGridValidatorService), ɵngcc0.ɵɵdirectiveInject(BmyecEventQueueService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService)); };
BmyecNetIncomeDistributionGridComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BmyecNetIncomeDistributionGridComponent, selectors: [["bmyec-net-income-distribution-grid"]], viewQuery: function BmyecNetIncomeDistributionGridComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 5);
        ɵngcc0.ɵɵviewQuery(_c3, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.netIncomeDistGrid = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toolbar = _t.first);
    } }, decls: 11, vars: 7, consts: [[3, "translate"], [1, "bmyec-net-income-dist-grid-wrapper"], ["netIncomeGridWrapper", ""], ["data-qe-id", "bmyec-distribution-toolbar", 1, "navbar", "navbar-default", "bento-toolbar", "navbar-expand", 3, "items"], ["toolbar", ""], ["accountComboboxRow", ""], ["class", "bento-flex-grid bmyec-net-income-dist-grid-max-height", "key-action-tab", "Cycle", "data-qe-id", "bmyec-distribution-grid", 3, "itemsSource", "selectionMode", "showSort", "showErrors", "validateEdits", "isReadOnly", "itemFormatter", "autoRowHeights", "quickAutoSize", "itemsSourceChanging", "itemsSourceChanged", "initialized", "refreshing", "click", "cellEditEnded", 4, "ngIf"], ["class", "bento-flex-grid bmyec-empty-net-income-dist-grid", "data-qe-id", "bmyec-distribution-grid-no-equity-accounts", 4, "ngIf"], [3, "ownerId", "passedInData", "modalCancel", "modalClose", "accountAdded", 4, "ngIf"], ["key-action-tab", "Cycle", "data-qe-id", "bmyec-distribution-grid", 1, "bento-flex-grid", "bmyec-net-income-dist-grid-max-height", 3, "itemsSource", "selectionMode", "showSort", "showErrors", "validateEdits", "isReadOnly", "itemFormatter", "autoRowHeights", "quickAutoSize", "itemsSourceChanging", "itemsSourceChanged", "initialized", "refreshing", "click", "cellEditEnded"], ["netIncomeDistGrid", ""], ["wjFlexGridCellTemplate", "", 3, "cellType"], ["data-qe-id", "bmyec-distribution-grid-checkbox", 3, "width", "isReadOnly", "allowSorting", "allowDragging"], ["data-qe-id", "bmyec-distribution-grid-accounts", 3, "header", "width", "minWidth", "binding", "allowSorting", "allowDragging"], ["binding", "distributionPercentage", "format", "n6", "format", "n6", "data-qe-id", "bmyec-distribution-grid-distribution-percentage", 3, "header", "width", "minWidth", "allowSorting", "allowDragging"], ["binding", "distributionAmount", "data-qe-id", "bmyec-distribution-grid-distribution-amount", 3, "header", "width", "minWidth", "allowSorting", "allowDragging"], ["data-qe-id", "bmyec-distribution-grid-checkbox-header", 3, "ngModel", "indeterminate", "disabled", "change"], [3, "ngModel", "disabled", "ngModelChange", "change"], ["bentoFlexGridControl", "", 3, "ngModel", "itemsObservable", "options", "appendTo", "rowTemplate", "placeholder", "ngModelChange"], ["format", "n6", 3, "isRequired", "value", "valueChange"], ["format", "n2", 3, "isRequired", "value", "valueChange"], ["data-qe-id", "bmyec-distribution-grid-no-equity-accounts", 1, "bento-flex-grid", "bmyec-empty-net-income-dist-grid"], ["data-qe-id", "bmyec-distribution-grid-no-equity-accounts-title", 1, "bmyec-no-equity-title", 3, "translate"], ["data-qe-id", "bmyec-distribution-grid-no-equity-accounts-message", 1, "bmyec-no-equity-message", 3, "translate"], [1, "row", "justify-content-md-center"], ["id", "bmyec-main-close-year", "type", "button", "data-qe-id", "bmyec-distribution-grid-add-equity-account", 1, "btn", "btn-primary", "btn-sm", "bmyec-add-equity-account-label", 3, "click"], [3, "ownerId", "passedInData", "modalCancel", "modalClose", "accountAdded"]], template: function BmyecNetIncomeDistributionGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵelementStart(2, "div", 1, 2);
        ɵngcc0.ɵɵelement(4, "bento-toolbar", 3, 4);
        ɵngcc0.ɵɵtemplate(6, BmyecNetIncomeDistributionGridComponent_ng_template_6_Template, 2, 1, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, BmyecNetIncomeDistributionGridComponent_wj_flex_grid_8_Template, 17, 43, "wj-flex-grid", 6);
        ɵngcc0.ɵɵtemplate(9, BmyecNetIncomeDistributionGridComponent_div_9_Template, 9, 9, "div", 7);
        ɵngcc0.ɵɵtemplate(10, BmyecNetIncomeDistributionGridComponent_bmaa_add_account_10_Template, 1, 2, "bmaa-add-account", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(1, 5, "bmyec_select_equity_accounts"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("items", ctx.toolbarButtons);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasEquityAccounts);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasEquityAccounts);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.modalOpened);
    } }, directives: function () { return [ɵngcc1.TranslateDirective, ɵngcc4.BentoToolbarComponent, ɵngcc2.NgbNavbar, ɵngcc5.NgIf, ɵngcc7.WjFlexGrid, ɵngcc7.WjFlexGridCellTemplate, ɵngcc7.WjFlexGridColumn, ɵngcc4.BentoCheckboxComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc4.BentoComboboxComponent, ɵngcc8.BentoComboboxFlexGridControlDirective, ɵngcc9.WjInputNumber, ɵngcc4.BentoFocusMonitorDirective, ɵngcc10.AddAccountComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe, BmyecFormatNumberPipe]; }, styles: [".bmyec-empty-net-income-dist-grid{height:204px}.bmyec-no-equity-title{font-size:22px;font-style:normal;font-weight:400;margin:15px;text-align:center}.bmyec-grid-header-capitalization{text-transform:none!important}.bmyec-no-equity-message{font-size:14px;font-style:normal;font-weight:400;margin:1em;text-align:center}.bmyec-add-equity-account-label{font-weight:700;margin-top:10px;text-align:center}.bmyec-net-income-dist-grid-max-height{max-height:21.4em}.bmyec-net-income-dist-grid-wrapper{margin-top:.5rem;max-width:99.9%}.bmyec-input wj-input-number{border:hidden}.bmyec-cell-error-tooltip{background-color:#fff;color:#000;font-weight:400;padding-right:25px}.bmyec-cell-error-tooltip:before{content:\"\"}.bmyec-cell-error-tooltip:after{border-top:6px solid #fff}.bmyec-net-income-dist-grid-wrapper .wj-cell.wj-header.wj-align-center.wj-state-invalid{border-color:#d5d4d9 #d5d4d9 #d5d4d9 #212121!important;border-style:solid solid solid none!important;border-width:0 1px 1px 0!important}:host::ng-deep .bmyec-text-alignment-right{text-align:right}:host::ng-deep .bmyec-checkbox{padding:9px 7px!important;text-align:center}:host::ng-deep div.bento-combobox-container-footer{padding:0}:host::ng-deep bento-combobox.bento-select div[role=combobox] input[type=text]{font-size:13px}:host::ng-deep .wj-cell.wj-header.wj-align-center.wj-state-invalid{border-bottom:1px solid #d5d4d9!important;border-left:0!important;border-right:1px solid #d5d4d9!important;border-top:0!important;pointer-events:none}:host::ng-deep .wj-content.wj-inputnumber{border:0}"], encapsulation: 2 });
BmyecNetIncomeDistributionGridComponent.ctorParameters = () => [
    { type: Store },
    { type: BmyecToolbarService },
    { type: BmyecGridValidatorService },
    { type: BmyecEventQueueService },
    { type: TranslateService }
];
BmyecNetIncomeDistributionGridComponent.propDecorators = {
    netIncomeDistGrid: [{ type: ViewChild, args: ['netIncomeDistGrid', { static: false },] }],
    toolbar: [{ type: ViewChild, args: ['toolbar', { static: true },] }]
};

class BmyecNetIncomeDistributionTableComponent {
    /**
     * @description
     * Creates an instance of bmyec net income distribution table component.
     *
     * @param store the store for the year end close state.
     */
    constructor(store) {
        this.store = store;
        this.oneHundredPercent = 100;
        this.constants = bmyecConstants;
        this.subscription$ = new Subject();
        this.hasEquityAccounts = false;
    }
    /**
     * @description
     *
     * Runs the code when the component is initialized.
     */
    ngOnInit() {
        this.store.pipe(select(getHasEquityAccounts))
            .pipe(takeUntil(this.subscription$))
            .subscribe(hasEquityAccounts => this.hasEquityAccounts = hasEquityAccounts);
    }
    /**
     * @description
     *
     * Validates is the net income has not been fully distributed.
     */
    isNetIncomePartiallyDistributed() {
        return this.distributionSummary.netIncomeTotal !== this.distributionSummary.distributedAmount
            && this.distributionSummary.remainingAmount !== 0 && this.hasEquityAccounts;
    }
    /**
     * @description
     *
     * Receives a numeric value (amount or percentage) and will return the same if equity account
     * where loaded, else will return zero.
     */
    getDisplayValueBasedOnEquityAccounts(value) {
        if (this.hasEquityAccounts && this.distributionSummary.netIncomeTotal !== 0) {
            return value;
        }
        return 0;
    }
    /**
     * @description
     *
     * executes when the component is destroyed.
     */
    ngOnDestroy() {
        if (this.subscription$) {
            this.subscription$.next();
            this.subscription$.complete();
        }
    }
}
BmyecNetIncomeDistributionTableComponent.ɵfac = function BmyecNetIncomeDistributionTableComponent_Factory(t) { return new (t || BmyecNetIncomeDistributionTableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Store)); };
BmyecNetIncomeDistributionTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BmyecNetIncomeDistributionTableComponent, selectors: [["bmyec-net-income-distribution-table"]], inputs: { distributionSummary: "distributionSummary" }, decls: 32, vars: 30, consts: [["translate", "bmyec_distribution_calculation_selected_equity_accounts"], ["attr.data-qe-id", "bmyec.netIncomeDistributionTable", 1, "table", "bmyec-table"], [1, "bmyec-table-header"], ["scope", "col", "headers", "blank", "translate", "bmyec_distribution"], ["scope", "col", "headers", "blank", "translate", "bmyec_percentage"], ["scope", "col", "headers", "blank", "translate", "bmyec_amount"], ["translate", "bmyec_total_net_income"], ["translate", "bmyec_distributed_net_income"], ["translate", "bmyec_difference"], [3, "ngClass"]], template: function BmyecNetIncomeDistributionTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "label", 0);
        ɵngcc0.ɵɵelementStart(1, "table", 1)(2, "thead", 2)(3, "tr");
        ɵngcc0.ɵɵelement(4, "td", 3)(5, "td", 4)(6, "td", 5);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "tbody")(8, "tr");
        ɵngcc0.ɵɵelement(9, "td", 6);
        ɵngcc0.ɵɵelementStart(10, "td");
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "number");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "td");
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "bmyecFormatNumberPipe");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(16, "tr");
        ɵngcc0.ɵɵelement(17, "td", 7);
        ɵngcc0.ɵɵelementStart(18, "td");
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "number");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "td");
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "bmyecFormatNumberPipe");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(24, "tr");
        ɵngcc0.ɵɵelement(25, "td", 8);
        ɵngcc0.ɵɵelementStart(26, "td", 9);
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵpipe(28, "number");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "td", 9);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "bmyecFormatNumberPipe");
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(12, 8, ctx.oneHundredPercent, ctx.constants.PERCENTAGE_FORMAT_NUMBER), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(15, 11, ctx.distributionSummary.netIncomeTotal, ctx.constants.AMOUNT_FORMAT_NUMBER), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(20, 14, ctx.getDisplayValueBasedOnEquityAccounts(ctx.distributionSummary.distributedPercentage), ctx.constants.PERCENTAGE_FORMAT_NUMBER), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(23, 17, ctx.getDisplayValueBasedOnEquityAccounts(ctx.distributionSummary.distributedAmount), ctx.constants.AMOUNT_FORMAT_NUMBER), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(26, _c4, ctx.isNetIncomePartiallyDistributed()));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(28, 20, ctx.getDisplayValueBasedOnEquityAccounts(ctx.distributionSummary.remainingPercentage), ctx.constants.PERCENTAGE_FORMAT_NUMBER), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(28, _c4, ctx.isNetIncomePartiallyDistributed()));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(31, 23, ctx.getDisplayValueBasedOnEquityAccounts(ctx.distributionSummary.remainingAmount), ctx.constants.AMOUNT_FORMAT_NUMBER), " ");
    } }, directives: function () { return [ɵngcc1.TranslateDirective, ɵngcc5.NgClass]; }, pipes: function () { return [ɵngcc5.DecimalPipe, BmyecFormatNumberPipe]; }, styles: [".bmyec-table-header[_ngcontent-%COMP%]{background-color:#f4f5f7;font-weight:700}.bmyec-distribution-difference[_ngcontent-%COMP%]{color:red}.bmyec-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:first-child{width:40%}.bmyec-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:not(:first-child){text-align:right;width:30%}"] });
BmyecNetIncomeDistributionTableComponent.ctorParameters = () => [
    { type: Store }
];
BmyecNetIncomeDistributionTableComponent.propDecorators = {
    distributionSummary: [{ type: Input }]
};

class BmyecNetIncomeDistributionComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.netIncomeTotal$ = this.store.pipe(select(getNetIncomeTotal));
        this.distributionSummary$ = this.store.pipe(select(getNetIncomeDistributionSummary));
    }
}
BmyecNetIncomeDistributionComponent.ɵfac = function BmyecNetIncomeDistributionComponent_Factory(t) { return new (t || BmyecNetIncomeDistributionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Store)); };
BmyecNetIncomeDistributionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BmyecNetIncomeDistributionComponent, selectors: [["bmyec-net-income-distribution"]], decls: 10, vars: 6, consts: [[1, "row"], [1, "col-md-7"], [1, "col-md-5"], [3, "distributionSummary", 4, "ngIf"], [3, "distributionSummary"]], template: function BmyecNetIncomeDistributionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "h2");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 0)(5, "div", 1);
        ɵngcc0.ɵɵelement(6, "bmyec-net-income-distribution-grid");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵtemplate(8, BmyecNetIncomeDistributionComponent_bmyec_net_income_distribution_table_8_Template, 2, 3, "bmyec-net-income-distribution-table", 3);
        ɵngcc0.ɵɵpipe(9, "async");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "bmyec_distribution_net_income"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(9, 4, ctx.distributionSummary$));
    } }, directives: [BmyecNetIncomeDistributionGridComponent, ɵngcc5.NgIf, BmyecNetIncomeDistributionTableComponent], pipes: [ɵngcc1.TranslatePipe, ɵngcc5.AsyncPipe], styles: [".bmyec-distribution-net-income-title[_ngcontent-%COMP%]{margin-top:1em}"] });
BmyecNetIncomeDistributionComponent.ctorParameters = () => [
    { type: Store }
];

class YearEndCloseSettingEffects {
    /**
     * @description
     *
     * Creates an instance of year end close setting effects.
     *
     * @param actions$ te actions to relate to.
     * @param yearEndCloseService the year end close service.
     */
    constructor(actions$, yearEndCloseService) {
        this.actions$ = actions$;
        this.yearEndCloseService = yearEndCloseService;
        /**
         * @description
         *
         * The store effect for the year end close settings.
         */
        this.loadYearEndCloseSettings$ = this.actions$.pipe(ofType(YearEndCloseSettingActionTypes.LoadYearEndCloseSettings), concatMap((action) => this.yearEndCloseService.getYearEndCloseSettings(action.payload.ownerId, action.payload.fiscalYearId).pipe(map((data) => {
            // If the back end doesn't return a value for enableZeroOutAccountBalances
            if (data.enableZeroOutAccountBalances === undefined) {
                data.enableZeroOutAccountBalances = true;
            }
            return new LoadYearEndCloseSettingsSuccess({ data });
        }), catchError(() => {
            const defaultSettings = Object.assign(Object.assign({}, YEAR_END_CLOSE_DEFAULT_SETTINGS), { fiscalYearId: action.payload.fiscalYearId });
            return of(new LoadYearEndCloseSettingsFailure({ defaultSettings }));
        }))));
    }
}
YearEndCloseSettingEffects.ɵfac = function YearEndCloseSettingEffects_Factory(t) { return new (t || YearEndCloseSettingEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions), ɵngcc0.ɵɵinject(ɵngcc12.YearEndCloseService)); };
YearEndCloseSettingEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: YearEndCloseSettingEffects, factory: YearEndCloseSettingEffects.ɵfac });
YearEndCloseSettingEffects.ctorParameters = () => [
    { type: Actions },
    { type: YearEndCloseService }
];
__decorate([
    Effect()
], YearEndCloseSettingEffects.prototype, "loadYearEndCloseSettings$", void 0);

class YearEndCloseInputsEffects {
    constructor(actions$) {
        this.actions$ = actions$;
    }
}
YearEndCloseInputsEffects.ɵfac = function YearEndCloseInputsEffects_Factory(t) { return new (t || YearEndCloseInputsEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions)); };
YearEndCloseInputsEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: YearEndCloseInputsEffects, factory: YearEndCloseInputsEffects.ɵfac });
YearEndCloseInputsEffects.ctorParameters = () => [
    { type: Actions }
];

class EquityAccountEffects {
    constructor(actions$, accountService) {
        this.actions$ = actions$;
        this.accountService = accountService;
        /**
         * Calls the accounting service to load the Equity Accounts.
         */
        this.loadEquityAccountStates$ = this.actions$.pipe(ofType(EquityAccountStateActionTypes.LoadEquityAccounts), concatMap((action) => this.accountService.getByFinancialReportType(action.payload.ownerId, [FinancialReportTypes.Equity]).pipe(map(data => new LoadEquityAccountsSuccess({ data })), catchError(error => of(new LoadEquityAccountsFailure({ error }))))));
    }
}
EquityAccountEffects.ɵfac = function EquityAccountEffects_Factory(t) { return new (t || EquityAccountEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions), ɵngcc0.ɵɵinject(ɵngcc12.AccountService)); };
EquityAccountEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EquityAccountEffects, factory: EquityAccountEffects.ɵfac });
EquityAccountEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountService }
];
__decorate([
    Effect()
], EquityAccountEffects.prototype, "loadEquityAccountStates$", void 0);

class AccountBalanceTypeEffects {
    constructor(actions$, accountBalanceTypeService) {
        this.actions$ = actions$;
        this.accountBalanceTypeService = accountBalanceTypeService;
        /**
         * Calls the accounting service to load the Account Balance Types.
         */
        this.loadAccountBalanceTypes$ = this.actions$.pipe(ofType(AccountBalanceTypeActionTypes.LoadAccountBalanceTypes), concatMap((action) => this.accountBalanceTypeService.get(action.payload.ownerId).pipe(map(data => new LoadAccountBalanceTypesSuccess({ data })), catchError(error => of(new LoadAccountBalanceTypesFailure({ error }))))));
    }
}
AccountBalanceTypeEffects.ɵfac = function AccountBalanceTypeEffects_Factory(t) { return new (t || AccountBalanceTypeEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions), ɵngcc0.ɵɵinject(ɵngcc12.AccountBalanceTypeService)); };
AccountBalanceTypeEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountBalanceTypeEffects, factory: AccountBalanceTypeEffects.ɵfac });
AccountBalanceTypeEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountBalanceTypeService }
];
__decorate([
    Effect()
], AccountBalanceTypeEffects.prototype, "loadAccountBalanceTypes$", void 0);

class AccountGroupsEffects {
    constructor(actions$, accountGroupService) {
        this.actions$ = actions$;
        this.accountGroupService = accountGroupService;
        /**
         * Calls the account groups service to load the Account Groups.
         */
        this.loadAccountGroups$ = this.actions$.pipe(ofType(AccountGroupsActionTypes.LoadAccountGroups), switchMap((action) => this.accountGroupService.get(action.payload.ownerId).pipe(mergeMap((data) => {
            const categoryNodesActions = data.map(accountGroup => {
                return new LoadCategoryNodeOptions({
                    ownerId: action.payload.ownerId,
                    accountGroupId: accountGroup.id,
                    financialReportTypes: [FinancialReportTypes.Equity]
                });
            });
            const accountGroupAction = [new LoadAccountGroupsSuccess({ data, ownerId: action.payload.ownerId })];
            return [...categoryNodesActions, ...accountGroupAction];
        }), catchError(error => of(new LoadAccountGroupsFailure({ error }))))));
    }
}
AccountGroupsEffects.ɵfac = function AccountGroupsEffects_Factory(t) { return new (t || AccountGroupsEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions), ɵngcc0.ɵɵinject(ɵngcc12.AccountGroupService)); };
AccountGroupsEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountGroupsEffects, factory: AccountGroupsEffects.ɵfac });
AccountGroupsEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountGroupService }
];
__decorate([
    Effect()
], AccountGroupsEffects.prototype, "loadAccountGroups$", void 0);

class CategoryNodeOptionsEffects {
    constructor(actions$, categoryNodeService) {
        this.actions$ = actions$;
        this.categoryNodeService = categoryNodeService;
        /**
         * Calls the accounting service to load the Category Node  Options.
         */
        this.loadCategoryNodeOptions$ = this.actions$.pipe(ofType(CategoryNodeOptionsActionTypes.LoadCategoryNodeOptions), concatMap((action) => this.categoryNodeService.getMappingOptions(action.payload.ownerId, action.payload.accountGroupId, true, action.payload.financialReportTypes).pipe(map((categoryNodeOptions) => new LoadCategoryNodeOptionsSuccess({
            categoryNodeOptions,
            accountGroupId: action.payload.accountGroupId
        })), catchError(() => of(new LoadCategoryNodeOptionsFailure({ accountGroupId: action.payload.accountGroupId }))))));
    }
}
CategoryNodeOptionsEffects.ɵfac = function CategoryNodeOptionsEffects_Factory(t) { return new (t || CategoryNodeOptionsEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions), ɵngcc0.ɵɵinject(ɵngcc12.CategoryNodeService)); };
CategoryNodeOptionsEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CategoryNodeOptionsEffects, factory: CategoryNodeOptionsEffects.ɵfac });
CategoryNodeOptionsEffects.ctorParameters = () => [
    { type: Actions },
    { type: CategoryNodeService }
];
__decorate([
    Effect()
], CategoryNodeOptionsEffects.prototype, "loadCategoryNodeOptions$", void 0);

class NetIncomeDistributionDataEffects {
    constructor(actions$, accountBalanceService) {
        this.actions$ = actions$;
        this.accountBalanceService = accountBalanceService;
        /**
         * Effect  of net income distribution data effects
         */
        this.loadNetIncomeTotals$ = this.actions$.pipe(ofType(NetIncomeDistributionDataActionTypes.LoadNetIncomeTotals), concatMap((action) => {
            const balanceTotalParamaters = {
                accountBalanceTypeIds: [action.payload.adjustedBalanceTypeId],
                useNetValue: true,
                includeType: IncludeType.BeginningBalanceAndPriorPeriods,
                yearString: '0',
                periodString: action.payload.periodSequenceNumber
            };
            return this.accountBalanceService.getNetIncomeTotalsUsingParamaters(action.payload.ownerId, balanceTotalParamaters).pipe(map((data) => {
                return new LoadNetIncomeTotalsSuccess({
                    netIncomeTotals: data,
                    adjustedBalanceTypeId: action.payload.adjustedBalanceTypeId
                });
            }), catchError(error => of(new LoadNetIncomeTotalsFailure({ error }))));
        }));
        /**
         * Effect  of update net income distribution data effects
         */
        this.updateNetIncomeDistributions$ = this.actions$.pipe(ofType(NetIncomeDistributionDataActionTypes.AddNetIncomeDistribution, NetIncomeDistributionDataActionTypes.UpdateNetIncomeDistribution, NetIncomeDistributionDataActionTypes.SetNetIncomeDistributions, NetIncomeDistributionDataActionTypes.RemoveNetIncomeDistribution, NetIncomeDistributionDataActionTypes.LoadNetIncomeTotalsSuccess), concatMap(() => of(new UpdateNetIncomeDistributionsSummary())));
    }
}
NetIncomeDistributionDataEffects.ɵfac = function NetIncomeDistributionDataEffects_Factory(t) { return new (t || NetIncomeDistributionDataEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions), ɵngcc0.ɵɵinject(ɵngcc12.AccountBalanceService)); };
NetIncomeDistributionDataEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NetIncomeDistributionDataEffects, factory: NetIncomeDistributionDataEffects.ɵfac });
NetIncomeDistributionDataEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountBalanceService }
];
__decorate([
    Effect()
], NetIncomeDistributionDataEffects.prototype, "loadNetIncomeTotals$", void 0);
__decorate([
    Effect()
], NetIncomeDistributionDataEffects.prototype, "updateNetIncomeDistributions$", void 0);

class BmyecFormatNumberPipe {
    constructor(decimalPipe) {
        this.decimalPipe = decimalPipe;
    }
    /**
     * @description
     *
     * Formats a number as currency using locale rules.
     *
     * @param value The number to format.
     * @param digitInfo Decimal representation options, specified by a string
     * in the following format: {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}.
     *  - minIntegerDigits: The minimum number of integer digits before the decimal point. Default is 1.
     *  - minFractionDigits: The minimum number of digits after the decimal point. Default is 0.
     *  - maxFractionDigits: The maximum number of digits after the decimal point. Default is 3.
     */
    transform(value, digitInfo) {
        if (value === undefined || value === null || typeof (value) !== 'number') {
            return value;
        }
        let formattedNumber = this.decimalPipe.transform(value, digitInfo);
        if (value < 0) {
            formattedNumber = `(${formattedNumber.replace('-', '')})`;
        }
        return formattedNumber;
    }
}
BmyecFormatNumberPipe.ɵfac = function BmyecFormatNumberPipe_Factory(t) { return new (t || BmyecFormatNumberPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DecimalPipe, 16)); };
BmyecFormatNumberPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "bmyecFormatNumberPipe", type: BmyecFormatNumberPipe, pure: true });
BmyecFormatNumberPipe.ctorParameters = () => [
    { type: DecimalPipe }
];

class BmyecFormatDatePipe {
    /**
     * @description
     * Creates an instance of bmyec format date pipe.
     *
     * @param translate The translate service.
     *
     */
    constructor(translate) {
        this.translate = translate;
    }
    /**
     * @description
     *
     * Formats the date per current locale.
     *
     * @param value The date to format.
     *
     *  - if locale is 'en-US' format used is 'MM/DD/YYYY', else 'YYYY-MM-DD' is used.
     */
    transform(value) {
        if (value === undefined || value === null) {
            return '';
        }
        const lang = this.translate.currentLang.toLowerCase();
        const formats = {
            'en-us': 'MM/dd/yyyy',
            'en-ca': 'yyyy-MM-dd',
            'fr-ca': 'yyyy-MM-dd'
        };
        const fmt = formats[lang] || formats['en-us'];
        // Refer to https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments
        if (typeof value === 'string' || value === '[object String]') {
            value = parseISO(value);
        }
        return format(value, fmt);
    }
}
BmyecFormatDatePipe.ɵfac = function BmyecFormatDatePipe_Factory(t) { return new (t || BmyecFormatDatePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TranslateService, 16)); };
BmyecFormatDatePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "bmyecFormatDatePipe", type: BmyecFormatDatePipe, pure: true });
BmyecFormatDatePipe.ctorParameters = () => [
    { type: TranslateService }
];

class FiscalYearEffects {
    constructor(actions$, fiscalYearService) {
        this.actions$ = actions$;
        this.fiscalYearService = fiscalYearService;
        /**
         * @description
         *
         * Calls the accounting service to load the Fiscal Years.
         *
         */
        this.loadFiscalYears$ = this.actions$.pipe(ofType(FiscalYearActionTypes.LoadFiscalYears), concatMap((action) => this.fiscalYearService.get(action.payload.ownerId, true).pipe(map((data) => {
            const years = data.map(year => (Object.assign({}, year)));
            const sortedYears = years.sort((y1, y2) => y1.sequenceNumber - y2.sequenceNumber);
            sortedYears.forEach(year => {
                const periods = [...year.periods];
                year.periods = periods.sort((periodA, periodB) => periodA.sequenceNumber - periodB.sequenceNumber);
            });
            return new LoadFiscalYearsSuccess({ data: sortedYears });
        }), catchError(error => of(new LoadFiscalYearsFailure({ error }))))));
    }
}
FiscalYearEffects.ɵfac = function FiscalYearEffects_Factory(t) { return new (t || FiscalYearEffects)(ɵngcc0.ɵɵinject(ɵngcc11.Actions), ɵngcc0.ɵɵinject(ɵngcc12.FiscalYearService)); };
FiscalYearEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FiscalYearEffects, factory: FiscalYearEffects.ɵfac });
FiscalYearEffects.ctorParameters = () => [
    { type: Actions },
    { type: FiscalYearService }
];
__decorate([
    Effect()
], FiscalYearEffects.prototype, "loadFiscalYears$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecAlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecGridValidatorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }, { type: BmyecAlertService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecEventQueueService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecYearEndCloseModalComponent, [{
        type: Component,
        args: [{
                selector: 'bmyec-modal',
                template: "<bento-alert [items]=\"alerts\"></bento-alert>\n<div class=\"modal-header bmyec-workspace-modal-header bmyec-workspace-padding\" id=\"bmyec-modal-header\">\n  <div class=\"row\">\n    <div class=\"col-md-4 col-sm-4 hidden-xs\">\n      <h1 class=\"modal-title\">\n        {{'bmyec_year_end_close_modal_contact_display_name' | translate : { value: contactDisplayName } }}\n      </h1>\n    </div>\n    <div class=\"col-md-8 col-sm-8 col-xs-12 text-right\">\n      <button\n        type=\"button\"\n        class=\"btn btn-primary knowledge-bold\"\n        id=\"bmyec-year-end-close-main-close-year\"\n        #bmyecYearEndCloseMainCloseYear\n        data-qe-id=\"bmyec-year-end-close-main-close-year\"\n        (click)=\"save()\">\n          {{'bmyec_year_end_close_modal_close_year_save' | translate}}\n      </button>\n      <button\n        type=\"button\"\n        class=\"btn btn-outline-primary\"\n        id=\"bmyec-year-end-close-main-modal-cancel\"\n        data-qe-id=\"bmyec-year-end-close-main-modal-cancel\"\n        (click)=\"cancel()\">\n        {{'bmyec_year_end_close_modal_close_year_cancel' | translate}}\n      </button>\n    </div>\n  </div>\n</div>\n<div class=\"modal-workspace-body\">\n  <div class=\"bmyec-form-header\">\n    <h2>{{ 'bmyec_year_end_close_modal_fiscal_year_for' | translate : {value: fiscalYearEndDate | bmyecFormatDatePipe} }}</h2>\n    <span>{{ 'bmyec_manage_year_end_close_settings' | translate}}</span>\n  </div>\n  <div class=\"row mr-2\" *ngIf=\"yearEndCloseSettings !== undefined\">\n    <div class=\"col-md-12 col-sm-12\">\n      <div class=\"card\">\n        <div class=\"card-header\">{{'bmyec_closing_options_label' | translate}}</div>\n        <div class=\"card-body\">\n          <div class=\"row\">\n            <div class=\"col-md-4 col-sm-4 bmyec-bento-toggle\">\n              <label for=\"bmyec-clear-balances-toggle\"\n                class=\"bmyec-form-label\">{{'bmyec_zero_out_account_balances' | translate}}\n              </label>\n              <bento-toggle\n                (ngModelChange)=\"zeroOutBalanceChanged($event)\"\n                [ngModel]=\"yearEndCloseSettings.enableZeroOutAccountBalances\"\n                class=\"bmyec-clear-balances-toggle\"\n                data-qe-id=\"bmyec-main-toggle\">\n              </bento-toggle>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <bmyec-net-income-distribution\n                *ngIf=\"!yearEndCloseSettings.enableZeroOutAccountBalances\">\n              </bmyec-net-income-distribution>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc2.NgbActiveModal }, { type: ɵngcc3.Store }, { type: BmyecGridValidatorService }, { type: BmyecAlertService }, { type: BmyecEventQueueService }]; }, { closeYearButton: [{
            type: ViewChild,
            args: ['bmyecYearEndCloseMainCloseYear']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecYearEndCloseMainComponent, [{
        type: Component,
        args: [{
                selector: 'bmyec-year-end-close-main',
                template: "<div class=\"bmyec-ng-bento\"></div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmyec-workspace-modal .modal-dialog .modal-content{border:0!important;border-radius:0!important;height:100vh!important;margin:0!important;overflow-x:hidden!important;overflow-y:auto!important;padding:0!important;width:100%!important}.bmyec-workspace-modal .modal-dialog{margin:0}.bmyec-workspace-modal .bmyec-workspace-modal-header{background-color:#212121;border:0;box-shadow:0 1px 3px rgba(0,0,0,.1),0 1px 7px rgba(0,0,0,.15);clear:both;display:block;height:60px;line-height:53px;position:absolute;top:0;white-space:nowrap;width:100%;z-index:101}.bmyec-workspace-modal .bmyec-workspace-modal-header h1,.bmyec-workspace-modal .bmyec-workspace-modal-header h2,.bmyec-workspace-modal .bmyec-workspace-modal-header h3{color:#fff;line-height:60px;margin:0}.bmyec-workspace-padding{padding:0 10px!important}.bmyec-workspace-modal-header button{margin-left:10px;margin-right:5px}.bmyec-workspace-modal .modal-title{padding-left:10px!important}.bmyec-workspace-modal .modal-workspace-body{bottom:0;display:block;margin-left:10px;overflow:hidden;padding:20px;position:absolute;top:60px;width:100%}.bmyec-workspace-modal .modal-dialog{padding:0!important}.bmyec-form-header{margin-bottom:10px}.bmyec-form-label{padding-right:5px}.bmyec-ng-bento .fade{opacity:unset}.bmyec-bento-toggle bento-toggle{margin-left:20px}.bmyec-bento-toggle .bmyec-clear-balances-toggle{height:22px;width:36px}.bmyec-clear-balances-toggle .bento-toggle-nob{height:22px;width:22px}.bmyec-bento-toggle bento-toggle.on .bento-toggle-nob{left:13px!important}.ng-bento ngb-modal-window.bmyec-workspace-modal+ngb-modal-backdrop.modal-backdrop{z-index:1150!important}"]
            }]
    }], function () { return [{ type: ɵngcc2.NgbModal }, { type: ɵngcc3.Store }]; }, { modalClose: [{
            type: Output
        }], modalCancel: [{
            type: Output
        }], ownerId: [{
            type: Input
        }], fiscalYearId: [{
            type: Input
        }], fiscalYear: [{
            type: Input
        }], contactDisplayName: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecToolbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecNetIncomeDistributionGridComponent, [{
        type: Component,
        args: [{
                selector: 'bmyec-net-income-distribution-grid',
                template: "<div translate=\"{{ 'bmyec_select_equity_accounts' | translate}}\"></div>\n\n<div class=\"bmyec-net-income-dist-grid-wrapper\" #netIncomeGridWrapper>\n    <bento-toolbar\n        #toolbar\n        class=\"navbar navbar-default bento-toolbar navbar-expand\"\n        [items]=\"toolbarButtons\"\n        data-qe-id=\"bmyec-distribution-toolbar\">\n    </bento-toolbar>\n    <ng-template #accountComboboxRow let-$data=\"data\">\n        <div>\n            {{$data.row.displayString}}\n        </div>\n    </ng-template>\n    <wj-flex-grid\n        *ngIf=\"hasEquityAccounts\"\n        #netIncomeDistGrid\n        [itemsSource]=\"netIncomeDistributions\"\n        class=\"bento-flex-grid bmyec-net-income-dist-grid-max-height\"\n        key-action-tab=\"Cycle\"\n        [selectionMode]=\"'Row'\"\n        [showSort]=\"false\"\n        [showErrors]=\"showErrors\"\n        [validateEdits]=\"false\"\n        (itemsSourceChanging)=\"itemsSourceChanging()\"\n        (itemsSourceChanged)=\"itemsSourceChanged()\"\n        (initialized)=\"gridInitialized()\"\n        [isReadOnly]=\"isReadOnly\"\n        [itemFormatter]=\"itemFormatter\"\n        (refreshing)=\"refreshGridLayout()\"\n        [autoRowHeights]=\"true\"\n        [quickAutoSize]=\"true\"\n        (click)=\"onCellClicked($event)\"\n        (cellEditEnded)=\"cellEditEnded($event)\"\n        data-qe-id=\"bmyec-distribution-grid\">\n        <ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-row=\"row\">\n            {{row.index + 1}}\n        </ng-template>\n        <wj-flex-grid-column\n            [width]=\"30\"\n            [isReadOnly]=\"true\"\n            [allowSorting]=\"allowSorting\"\n            [allowDragging]=\"false\"\n            data-qe-id=\"bmyec-distribution-grid-checkbox\">\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'ColumnHeader'\">\n                <bento-checkbox\n                    [ngModel]=\"allSelected()\"\n                    (change)=\"onHeaderCheckboxChange()\"\n                    [indeterminate]=\"isHeaderIndeterminate()\"\n                    [disabled]=\"isReadOnly\"\n                    data-qe-id=\"bmyec-distribution-grid-checkbox-header\">\n                </bento-checkbox>\n            </ng-template>\n\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-item=\"item\" let-row=\"row\">\n                <bento-checkbox\n                    [(ngModel)]=\"item.selected\"\n                    (change)=\"setRowSelection(row.index, item)\"\n                    [disabled]=\"isReadOnly\">\n                </bento-checkbox>\n            </ng-template>\n        </wj-flex-grid-column>\n\n        <wj-flex-grid-column\n            [header]=\"'bmyec_equity_account' | translate\"\n            [width]=\"'*'\"\n            [minWidth]=\"100\"\n            [binding]=\"'account'\"\n            data-qe-id=\"bmyec-distribution-grid-accounts\"\n            [allowSorting]=\"allowSorting\"\n            [allowDragging]=\"false\">\n                <ng-template wjFlexGridCellTemplate [cellType]=\"'CellEdit'\" let-cell=\"cell\" let-row=\"row\" let-item=\"item\">\n                <bento-combobox\n                    [(ngModel)]=\"cell.value\"\n                    [itemsObservable]=\"getEquityAccountObservable(row.index)\"\n                    [options]=\"equityAccountComboboxOptions\"\n                    [appendTo]=\"netIncomeGridWrapper\"\n                    [rowTemplate]=\"accountComboboxRow\"\n                    (ngModelChange)=\"onAccountChange(cell.value, row.index, item)\"\n                    [attr.data-qe-id]=\"'bmyec-distribution-grid-accounts-combobox-' + row.index\"\n                    [placeholder]=\"'bmyec_equity_account_select' | translate\"\n                    bentoFlexGridControl>\n                </bento-combobox>\n            </ng-template>\n                <ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-item=\"item\">\n                    {{ item.account.displayString }}\n                </ng-template>\n        </wj-flex-grid-column>\n\n        <wj-flex-grid-column\n            [header]=\"'bmyec_percentage' | translate\"\n            [width]=\"'*'\"\n            [minWidth]=\"100\"\n            binding=\"distributionPercentage\"\n            format=\"n6\"\n            [allowSorting]=\"allowSorting\"\n            [allowDragging]=\"false\"\n            format=\"n6\"\n            data-qe-id=\"bmyec-distribution-grid-distribution-percentage\">\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'CellEdit'\" let-item=\"item\" let-row=\"row\">\n                <wj-input-number\n                    [isRequired]=\"false\"\n                    [(value)]=\"item.distributionPercentage\"\n                    format=\"n6\"\n                    [attr.data-qe-id]=\"'bmyec-distribution-grid-ditributionPercentage-' + row.index\">\n                </wj-input-number>\n            </ng-template>\n        </wj-flex-grid-column>\n\n        <wj-flex-grid-column\n            [header]=\"'bmyec_amount' | translate\"\n            [width]=\"'*'\"\n            [minWidth]=\"100\"\n            binding=\"distributionAmount\"\n            [allowSorting]=\"allowSorting\"\n            [allowDragging]=\"false\"\n            data-qe-id=\"bmyec-distribution-grid-distribution-amount\">\n            <ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-item=\"item\">\n                {{ item.distributionAmount | bmyecFormatNumberPipe: constants.AMOUNT_FORMAT_NUMBER }}\n            </ng-template>\n            <ng-template  wjFlexGridCellTemplate [cellType]=\"'CellEdit'\" let-item=\"item\" let-row=\"row\">\n                <wj-input-number\n                    [isRequired]=\"false\"\n                    [(value)]=\"item.distributionAmount\"\n                    format=\"n2\"\n                    [attr.data-qe-id]=\"'bmyec-distribution-grid-ditributionAmount-' + row.index\">\n                </wj-input-number>\n            </ng-template>\n        </wj-flex-grid-column>\n    </wj-flex-grid>\n    <div\n        *ngIf=\"!hasEquityAccounts\"\n        class=\"bento-flex-grid bmyec-empty-net-income-dist-grid\"\n        data-qe-id=\"bmyec-distribution-grid-no-equity-accounts\">\n        <div\n            class=\"bmyec-no-equity-title\"\n            translate=\"{{ 'bmyec_no_equity_accounts_title' | translate}}\"\n            data-qe-id=\"bmyec-distribution-grid-no-equity-accounts-title\">\n        </div>\n        <div\n            class=\"bmyec-no-equity-message\"\n            translate=\"{{ 'bmyec_no_equity_accounts_message' | translate}}\"\n            data-qe-id=\"bmyec-distribution-grid-no-equity-accounts-message\">\n        </div>\n        <div class=\"row justify-content-md-center\">\n            <button\n                class=\"btn btn-primary btn-sm bmyec-add-equity-account-label\"\n                id=\"bmyec-main-close-year\"\n                type=\"button\"\n                data-qe-id=\"bmyec-distribution-grid-add-equity-account\"\n                (click)=\"openAddEquityAccountModal()\">\n                {{ 'bmyec_add_equity_account' | translate }}\n            </button>\n        </div>\n    </div>\n    <bmaa-add-account\n        *ngIf=\"modalOpened\"\n        [ownerId]=\"ownerId\"\n        [passedInData]=\"addAccountSettings\"\n        (modalCancel)=\"setModalOpenedAsFalse()\"\n        (modalClose)=\"setIsCloseModalAsTrue()\"\n        (accountAdded)=\"addNewEquityAccount($event)\"\n    ></bmaa-add-account>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmyec-empty-net-income-dist-grid{height:204px}.bmyec-no-equity-title{font-size:22px;font-style:normal;font-weight:400;margin:15px;text-align:center}.bmyec-grid-header-capitalization{text-transform:none!important}.bmyec-no-equity-message{font-size:14px;font-style:normal;font-weight:400;margin:1em;text-align:center}.bmyec-add-equity-account-label{font-weight:700;margin-top:10px;text-align:center}.bmyec-net-income-dist-grid-max-height{max-height:21.4em}.bmyec-net-income-dist-grid-wrapper{margin-top:.5rem;max-width:99.9%}.bmyec-input wj-input-number{border:hidden}.bmyec-cell-error-tooltip{background-color:#fff;color:#000;font-weight:400;padding-right:25px}.bmyec-cell-error-tooltip:before{content:\"\"}.bmyec-cell-error-tooltip:after{border-top:6px solid #fff}.bmyec-net-income-dist-grid-wrapper .wj-cell.wj-header.wj-align-center.wj-state-invalid{border-color:#d5d4d9 #d5d4d9 #d5d4d9 #212121!important;border-style:solid solid solid none!important;border-width:0 1px 1px 0!important}:host::ng-deep .bmyec-text-alignment-right{text-align:right}:host::ng-deep .bmyec-checkbox{padding:9px 7px!important;text-align:center}:host::ng-deep div.bento-combobox-container-footer{padding:0}:host::ng-deep bento-combobox.bento-select div[role=combobox] input[type=text]{font-size:13px}:host::ng-deep .wj-cell.wj-header.wj-align-center.wj-state-invalid{border-bottom:1px solid #d5d4d9!important;border-left:0!important;border-right:1px solid #d5d4d9!important;border-top:0!important;pointer-events:none}:host::ng-deep .wj-content.wj-inputnumber{border:0}"]
            }]
    }], function () { return [{ type: ɵngcc3.Store }, { type: BmyecToolbarService }, { type: BmyecGridValidatorService }, { type: BmyecEventQueueService }, { type: ɵngcc1.TranslateService }]; }, { netIncomeDistGrid: [{
            type: ViewChild,
            args: ['netIncomeDistGrid', { static: false }]
        }], toolbar: [{
            type: ViewChild,
            args: ['toolbar', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecNetIncomeDistributionTableComponent, [{
        type: Component,
        args: [{
                selector: 'bmyec-net-income-distribution-table',
                template: "<label translate=\"bmyec_distribution_calculation_selected_equity_accounts\"></label>\n<table class=\"table bmyec-table\" attr.data-qe-id=\"bmyec.netIncomeDistributionTable\">\n  <thead class=\"bmyec-table-header\">\n    <tr>\n      <td scope=\"col\" headers=\"blank\" translate=\"bmyec_distribution\"></td>\n      <td scope=\"col\" headers=\"blank\" translate=\"bmyec_percentage\"></td>\n      <td scope=\"col\" headers=\"blank\" translate=\"bmyec_amount\"></td>\n    </tr>\n  </thead>\n  <tbody>\n    <tr>\n      <td translate=\"bmyec_total_net_income\"></td>\n      <td>\n        {{ oneHundredPercent | number: constants.PERCENTAGE_FORMAT_NUMBER }}\n      </td>\n      <td>\n        {{ distributionSummary.netIncomeTotal | bmyecFormatNumberPipe: constants.AMOUNT_FORMAT_NUMBER }}\n      </td>\n    </tr>\n    <tr>\n      <td translate=\"bmyec_distributed_net_income\"></td>\n      <td>\n        {{ getDisplayValueBasedOnEquityAccounts(distributionSummary.distributedPercentage) | number: constants.PERCENTAGE_FORMAT_NUMBER }}\n      </td>\n      <td>\n        {{ getDisplayValueBasedOnEquityAccounts(distributionSummary.distributedAmount) | bmyecFormatNumberPipe: constants.AMOUNT_FORMAT_NUMBER }}\n      </td>\n    </tr>\n    <tr>\n      <td translate=\"bmyec_difference\"></td>\n      <td [ngClass]=\"{'bmyec-distribution-difference': isNetIncomePartiallyDistributed() }\">\n        {{ getDisplayValueBasedOnEquityAccounts(distributionSummary.remainingPercentage) | number: constants.PERCENTAGE_FORMAT_NUMBER }}\n      </td>\n      <td [ngClass]=\"{'bmyec-distribution-difference': isNetIncomePartiallyDistributed() }\">\n        {{ getDisplayValueBasedOnEquityAccounts(distributionSummary.remainingAmount) | bmyecFormatNumberPipe: constants.AMOUNT_FORMAT_NUMBER }}\n      </td>\n    </tr>\n  </tbody>\n</table>",
                styles: [".bmyec-table-header{background-color:#f4f5f7;font-weight:700}.bmyec-distribution-difference{color:red}.bmyec-table td:first-child{width:40%}.bmyec-table td:not(:first-child){text-align:right;width:30%}"]
            }]
    }], function () { return [{ type: ɵngcc3.Store }]; }, { distributionSummary: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecNetIncomeDistributionComponent, [{
        type: Component,
        args: [{
                selector: 'bmyec-net-income-distribution',
                template: "<div>\n    <h2>{{'bmyec_distribution_net_income' | translate}}</h2>\n    <div class=\"row\">\n        <div class=\"col-md-7\">\n            <bmyec-net-income-distribution-grid></bmyec-net-income-distribution-grid>\n        </div>\n        <div class=\"col-md-5\">\n            <bmyec-net-income-distribution-table\n            *ngIf=\"(distributionSummary$ | async)\"\n            [distributionSummary]=\"distributionSummary$ | async\">\n        </bmyec-net-income-distribution-table>\n        </div>\n    </div>\n</div>\n",
                styles: [".bmyec-distribution-net-income-title{margin-top:1em}"]
            }]
    }], function () { return [{ type: ɵngcc3.Store }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(YearEndCloseSettingEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }, { type: ɵngcc12.YearEndCloseService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(YearEndCloseInputsEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EquityAccountEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }, { type: ɵngcc12.AccountService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountBalanceTypeEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }, { type: ɵngcc12.AccountBalanceTypeService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountGroupsEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }, { type: ɵngcc12.AccountGroupService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CategoryNodeOptionsEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }, { type: ɵngcc12.CategoryNodeService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NetIncomeDistributionDataEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }, { type: ɵngcc12.AccountBalanceService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecFormatNumberPipe, [{
        type: Pipe,
        args: [{
                name: 'bmyecFormatNumberPipe'
            }]
    }], function () { return [{ type: ɵngcc5.DecimalPipe }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmyecFormatDatePipe, [{
        type: Pipe,
        args: [{
                name: 'bmyecFormatDatePipe'
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FiscalYearEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc11.Actions }, { type: ɵngcc12.FiscalYearService }]; }, null); })();

class BluemoonYearEndCloseModule {
    ngDoBootsrap() { }
}
BluemoonYearEndCloseModule.ɵfac = function BluemoonYearEndCloseModule_Factory(t) { return new (t || BluemoonYearEndCloseModule)(); };
BluemoonYearEndCloseModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BluemoonYearEndCloseModule });
BluemoonYearEndCloseModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [DecimalPipe], imports: [[
            CommonModule,
            BrowserModule,
            BrowserAnimationsModule,
            BentoModule,
            NgbModule,
            FormsModule,
            UpgradeModule,
            HttpClientModule,
            TranslateModule.forChild(),
            AccountingServicesModule,
            StoreModule.forFeature(yearEndCloseStateFeatureKey, reducers, { metaReducers: metaReducers }),
            EffectsModule.forFeature([
                YearEndCloseSettingEffects,
                YearEndCloseInputsEffects,
                EquityAccountEffects,
                AccountBalanceTypeEffects,
                NetIncomeDistributionDataEffects,
                CategoryNodeOptionsEffects,
                AccountGroupsEffects,
                FiscalYearEffects
            ]),
            WjGridModule,
            WjInputModule,
            WjGridFilterModule,
            WjGridGrouppanelModule,
            BentoFlexGridControlModule,
            AddAccountModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BluemoonYearEndCloseModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BmyecYearEndCloseMainComponent,
                    BmyecYearEndCloseModalComponent,
                    BmyecNetIncomeDistributionComponent,
                    BmyecNetIncomeDistributionGridComponent,
                    BmyecNetIncomeDistributionTableComponent,
                    BmyecFormatNumberPipe,
                    BmyecFormatDatePipe
                ],
                imports: [
                    CommonModule,
                    BrowserModule,
                    BrowserAnimationsModule,
                    BentoModule,
                    NgbModule,
                    FormsModule,
                    UpgradeModule,
                    HttpClientModule,
                    TranslateModule.forChild(),
                    AccountingServicesModule,
                    StoreModule.forFeature(yearEndCloseStateFeatureKey, reducers, { metaReducers: metaReducers }),
                    EffectsModule.forFeature([
                        YearEndCloseSettingEffects,
                        YearEndCloseInputsEffects,
                        EquityAccountEffects,
                        AccountBalanceTypeEffects,
                        NetIncomeDistributionDataEffects,
                        CategoryNodeOptionsEffects,
                        AccountGroupsEffects,
                        FiscalYearEffects
                    ]),
                    WjGridModule,
                    WjInputModule,
                    WjGridFilterModule,
                    WjGridGrouppanelModule,
                    BentoFlexGridControlModule,
                    AddAccountModule
                ],
                exports: [BmyecYearEndCloseMainComponent],
                entryComponents: [BmyecYearEndCloseMainComponent, BmyecYearEndCloseModalComponent],
                providers: [DecimalPipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BluemoonYearEndCloseModule, { declarations: function () { return [BmyecYearEndCloseMainComponent, BmyecYearEndCloseModalComponent, BmyecNetIncomeDistributionComponent, BmyecNetIncomeDistributionGridComponent, BmyecNetIncomeDistributionTableComponent, BmyecFormatNumberPipe, BmyecFormatDatePipe]; }, imports: function () { return [CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        BentoModule,
        NgbModule,
        FormsModule,
        UpgradeModule,
        HttpClientModule, ɵngcc1.TranslateModule, AccountingServicesModule, ɵngcc3.StoreFeatureModule, ɵngcc11.EffectsFeatureModule, WjGridModule,
        WjInputModule,
        WjGridFilterModule,
        WjGridGrouppanelModule,
        BentoFlexGridControlModule,
        AddAccountModule]; }, exports: function () { return [BmyecYearEndCloseMainComponent]; } }); })();

/*
 * Public API Surface of bluemoon-year-end-close
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BluemoonYearEndCloseModule, BmyecYearEndCloseMainComponent, BmyecYearEndCloseModalComponent as ɵb, EquityAccountEffects as ɵbb, AccountBalanceTypeEffects as ɵbd, NetIncomeDistributionDataEffects as ɵbf, CategoryNodeOptionsEffects as ɵbh, AccountGroupsEffects as ɵbj, FiscalYearEffects as ɵbl, BmyecGridValidatorService as ɵc, BmyecAlertService as ɵd, BmyecEventQueueService as ɵe, BmyecNetIncomeDistributionComponent as ɵf, reducer$5 as ɵh, BmyecNetIncomeDistributionGridComponent as ɵi, BmyecToolbarService as ɵj, BmyecNetIncomeDistributionTableComponent as ɵk, BmyecFormatNumberPipe as ɵl, BmyecFormatDatePipe as ɵm, yearEndCloseStateFeatureKey as ɵn, reducers as ɵo, metaReducers as ɵp, reducer$7 as ɵq, reducer$6 as ɵr, reducer$4 as ɵs, reducer$3 as ɵt, reducer$2 as ɵu, reducer$1 as ɵv, reducer as ɵw, YearEndCloseSettingEffects as ɵx, YearEndCloseInputsEffects as ɵz };

